const messages = {
  Test: {
    defaultMessage: "test",
    id: "test",
  },

  Account: {
    Title: {
      defaultMessage: "Account settings",
      id: "account.title",
    },
    YourName: {
      defaultMessage: "Your name",
      id: "account.yourName",
    },
    Email: {
      defaultMessage: "Email",
      id: "account.email",
    },
    Edit: {
      defaultMessage: "Edit",
      id: "account.edit",
    },
    Password: {
      defaultMessage: "Password",
      id: "account.password",
    },
    SsoEmailControlled: {
      defaultMessage:
        "SSO is enabled. Email is controlled by your company\u2019s identity provider.",
      id: "account.ssoEmailControlled",
    },
    SsoPasswordControlled: {
      defaultMessage:
        "SSO is enabled. Password is controlled by your company\u2019s identity provider.",
      id: "account.ssoPasswordControlled",
    },
    TwoFactor: {
      Title: {
        defaultMessage: "Two-factor authentication (2FA)",
        id: "account.twoFactor.title",
      },
      SsoControlled: {
        defaultMessage:
          "SSO is enabled. 2FA is controlled by your company\u2019s identity provider.",
        id: "account.twoFactor.ssoControlled",
      },
      Enabled: {
        defaultMessage:
          "2FA is enabled. You will be prompted to enter a 6-digit code from your authenticator app at login and when performing certain actions",
        id: "account.twoFactor.enabled",
      },
      Disabled: {
        defaultMessage:
          "2FA is currently disabled. Enable this to strengthen account security with a one-time code required at login",
        id: "account.twoFactor.disabled",
      },
      Enable: {
        defaultMessage: "Enable",
        id: "account.twoFactor.enable",
      },
      Disable: {
        defaultMessage: "Disable",
        id: "account.twoFactor.disable",
      },
      VerifyEmail: {
        defaultMessage: "Verify your email address to enable 2FA",
        id: "account.twoFactor.verifyEmail",
      },
      VerificationSent: {
        defaultMessage: "Verification email sent! Check your inbox.",
        id: "account.twoFactor.verificationSent",
      },
      ResendVerification: {
        defaultMessage: "Resend verification email",
        id: "account.twoFactor.resendVerification",
      },
      Sending: {
        defaultMessage: "Sending...",
        id: "account.twoFactor.sending",
      },
    },
    LinkedPersonalAccount: {
      defaultMessage: "Linked personal account",
      id: "account.linkedPersonalAccount",
    },
    GiftExpires: {
      defaultMessage: "gift expires {date}",
      id: "account.giftExpires",
    },
    LinkPersonalEmail: {
      defaultMessage: "Link a personal email to receive a complimentary Shapr3D subscription.",
      id: "account.linkPersonalEmail",
    },
    LinkAccount: {
      defaultMessage: "Link account",
      id: "account.linkAccount",
    },
    DeleteAccountLink: {
      defaultMessage: "Delete account",
      id: "account.deleteAccount",
    },
    PermanentlyDelete: {
      defaultMessage: "Permanently delete this account and all the projects.",
      id: "account.permanentlyDelete",
    },
    EmailChange: {
      Title: {
        defaultMessage: "Edit email",
        id: "account.emailChange.title",
      },
      NewEmailPlaceholder: {
        defaultMessage: "New email address",
        id: "account.emailChange.newEmailPlaceholder",
      },
      PasswordPlaceholder: {
        defaultMessage: "Your password",
        id: "account.emailChange.passwordPlaceholder",
      },
      ValidationNewEmail: {
        defaultMessage: "Please enter a new email address",
        id: "account.emailChange.validationNewEmail",
      },
      ValidationInvalidEmail: {
        defaultMessage: "Invalid email",
        id: "account.emailChange.validationInvalidEmail",
      },
      ValidationPassword: {
        defaultMessage: "Please enter your password.",
        id: "account.emailChange.validationPassword",
      },
      IncorrectPassword: {
        defaultMessage: "Incorrect password. Please try again.",
        id: "account.emailChange.incorrectPassword",
      },
      ConfirmationInfo: {
        defaultMessage:
          "A confirmation link will be sent to your new email address to verify your email before you start using it with Shapr3D.",
        id: "account.emailChange.confirmationInfo",
      },
      SendConfirmationLink: {
        defaultMessage: "Send confirmation link",
        id: "account.emailChange.sendConfirmationLink",
      },
      CheckMailbox: {
        defaultMessage: "Check your mailbox.",
        id: "account.emailChange.checkMailbox",
      },
      ConfirmationSent: {
        defaultMessage: "The confirmation link has been sent to <email>{emailAddress}</email>",
        id: "account.emailChange.confirmationSent",
      },
      Close: {
        defaultMessage: "Close",
        id: "account.emailChange.close",
      },
    },
    ConfirmEmailChange: {
      LinkExpired: {
        defaultMessage: "Link expired",
        id: "account.confirmEmailChange.linkExpired",
      },
      ExpiredDescription: {
        defaultMessage:
          "The confirmation link you followed expired in the meantime. Please request a new one.",
        id: "account.confirmEmailChange.expiredDescription",
      },
      RequestAnother: {
        defaultMessage: "Request another",
        id: "account.confirmEmailChange.requestAnother",
      },
      BackToAccount: {
        defaultMessage: "Back to account",
        id: "account.confirmEmailChange.backToAccount",
      },
      SignInToRequest: {
        defaultMessage: "Sign in to request another",
        id: "account.confirmEmailChange.signInToRequest",
      },
      Success: {
        defaultMessage: "Success!",
        id: "account.confirmEmailChange.success",
      },
      BackToLogin: {
        defaultMessage: "Back to login",
        id: "account.confirmEmailChange.backToLogin",
      },
      SuccessDescription: {
        defaultMessage: "Your email address has been successfully updated to {newEmail}",
        id: "account.confirmEmailChange.successDescription",
      },
    },
    PasswordChange: {
      Title: {
        defaultMessage: "Edit password",
        id: "account.passwordChange.title",
      },
      CurrentPassword: {
        defaultMessage: "Current password",
        id: "account.passwordChange.currentPassword",
      },
      NewPassword: {
        defaultMessage: "New password",
        id: "account.passwordChange.newPassword",
      },
      ReEnterNewPassword: {
        defaultMessage: "Re-enter new password",
        id: "account.passwordChange.reEnterNewPassword",
      },
      ValidationCurrentPassword: {
        defaultMessage: "Please enter your password.",
        id: "account.passwordChange.validationCurrentPassword",
      },
      ValidationPasswordMismatch: {
        defaultMessage: "New password and confirmation do not match.",
        id: "account.passwordChange.validationPasswordMismatch",
      },
      UpdatePassword: {
        defaultMessage: "Update password",
        id: "account.passwordChange.updatePassword",
      },
      Success: {
        defaultMessage: "You\u2019ve successfully updated your password.",
        id: "account.passwordChange.success",
      },
      Close: {
        defaultMessage: "Close",
        id: "account.passwordChange.close",
      },
    },
    DeleteAccount: {
      Title: {
        defaultMessage: "Delete your account",
        id: "account.deleteAccount.title",
      },
      EmailDoesNotMatch: {
        defaultMessage: "Email does not match",
        id: "account.deleteAccount.emailDoesNotMatch",
      },
      BeforeDeletingExportOnly: {
        defaultMessage:
          "Before deleting your account, <exportLink>export</exportLink> your projects.",
        id: "account.deleteAccount.beforeDeletingExportOnly",
      },
      BeforeDeletingExportAndCancel: {
        defaultMessage:
          "Before deleting your account, <exportLink>export</exportLink> your projects and <cancelLink>cancel your subscription</cancelLink>.",
        id: "account.deleteAccount.beforeDeletingExportAndCancel",
      },
      PermanentlyDeleteModal: {
        defaultMessage:
          "To permanently delete your account and all of your projects, enter the email address associated with your account.",
        id: "account.deleteAccount.permanentlyDelete",
      },
      LearnMore: {
        defaultMessage: "Learn more about how Shapr3D handles your data <link>here</link>.",
        id: "account.deleteAccount.learnMore",
      },
      Cancel: {
        defaultMessage: "Cancel",
        id: "account.deleteAccount.cancel",
      },
      DeleteButton: {
        defaultMessage: "Delete account",
        id: "account.deleteAccount.deleteButton",
      },
    },
    NameChange: {
      Title: {
        defaultMessage: "Edit your name",
        id: "account.nameChange.title",
      },
      Placeholder: {
        defaultMessage: "Your name",
        id: "account.nameChange.placeholder",
      },
      Save: {
        defaultMessage: "Save",
        id: "account.nameChange.save",
      },
    },
  },

  Checkout: {
    // Main checkout page
    StartFreeTrial: {
      defaultMessage: "Start your {trialDays}-day free trial",
      id: "checkout.startFreeTrial",
    },
    SubscribeNow: {
      defaultMessage: "Subscribe now",
      id: "checkout.subscribeNow",
    },
    SubscribeNowSubtitle: {
      defaultMessage: "Access to all features without limits.",
      id: "checkout.subscribeNowSubtitle",
    },
    NumberOfSeats: {
      defaultMessage: "Number of seats",
      id: "checkout.numberOfSeats",
    },
    IncludingYou: {
      defaultMessage: "(Including you)",
      id: "checkout.includingYou",
    },
    BillingPeriod: {
      defaultMessage: "Billing period",
      id: "checkout.billingPeriod",
    },
    PaymentMethod: {
      defaultMessage: "Payment method",
      id: "checkout.paymentMethod",
    },
    ApplePay: {
      defaultMessage: "Apple Pay",
      id: "checkout.applePay",
    },
    CreditDebitCard: {
      defaultMessage: "Credit/debit card",
      id: "checkout.creditDebitCard",
    },
    CreditCardDetails: {
      defaultMessage: "Credit card details",
      id: "checkout.creditCardDetails",
    },
    ContactingCardIssuer: {
      defaultMessage: "Contacting your card issuer...",
      id: "checkout.contactingCardIssuer",
    },
    SelectPaymentMethod: {
      defaultMessage: "Please select a payment method",
      id: "checkout.selectPaymentMethod",
    },
    ProvideCardInfo: {
      defaultMessage: "Please provide your card information",
      id: "checkout.provideCardInfo",
    },
    SomethingWentWrongRetry: {
      defaultMessage: "Something went wrong. Please try again.",
      id: "checkout.somethingWentWrongRetry",
    },
    Yearly: {
      defaultMessage: "Yearly",
      id: "checkout.yearly",
    },
    Monthly: {
      defaultMessage: "Monthly",
      id: "checkout.monthly",
    },

    // Toast messages
    Toast: {
      TrialActivated: {
        defaultMessage: "Your team's trial is activated!",
        id: "checkout.toast.trialActivated",
      },
      SubscriptionActivated: {
        defaultMessage: "Your team's Shapr3D Pro subscription is activated!",
        id: "checkout.toast.subscriptionActivated",
      },
      SoloSubscriptionActivated: {
        defaultMessage: "Your Shapr3D Solo subscription is activated!",
        id: "checkout.toast.soloSubscriptionActivated",
      },
      StudioSubscriptionActivated: {
        defaultMessage: "Your Shapr3D Studio subscription is activated!",
        id: "checkout.toast.studioSubscriptionActivated",
      },
      UpgradeToStudio: {
        defaultMessage: "Your subscription has been upgraded to Studio.",
        id: "checkout.toast.upgradeToStudio",
      },
      InvitationSent: {
        defaultMessage: "Invitation sent!",
        id: "checkout.toast.invitationSent",
      },
      SeatsAdded: {
        defaultMessage: "{count} {count, plural, one {seat} other {seats}} added to your team.",
        id: "checkout.toast.seatsAdded",
      },
      VerificationEmailSent: {
        defaultMessage: "Verification email sent to ",
        id: "checkout.toast.verificationEmailSent",
      },
    },

    // Billing info form
    BillingInfo: {
      Title: {
        defaultMessage: "Billing information",
        id: "checkout.billingInfo.title",
      },
      Optional: {
        defaultMessage: " (Optional)",
        id: "checkout.billingInfo.optional",
      },
      Description: {
        defaultMessage:
          "This information will be displayed on your invoice and used to calculate taxes.",
        id: "checkout.billingInfo.description",
      },
      AddCompanyDetails: {
        defaultMessage: "Add company details",
        id: "checkout.billingInfo.addCompanyDetails",
      },
      VerificationErrorTitle: {
        defaultMessage: "We couldn't verify your billing details.",
        id: "checkout.billingInfo.verificationErrorTitle",
      },
      VerificationErrorText: {
        defaultMessage:
          "Please review your details. Let us know if we can help if the issue persists.",
        id: "checkout.billingInfo.verificationErrorText",
      },
      ContactUs: {
        defaultMessage: "Contact Us",
        id: "checkout.billingInfo.contactUs",
      },
      NameOnBill: {
        defaultMessage: "Name on the bill",
        id: "checkout.billingInfo.nameOnBill",
      },
      AddressLine1: {
        defaultMessage: "Address Line 1",
        id: "checkout.billingInfo.addressLine1",
      },
      AddressLine2: {
        defaultMessage: "Address Line 2",
        id: "checkout.billingInfo.addressLine2",
      },
      AddressLine2Optional: {
        defaultMessage: "Address Line 2 (Optional)",
        id: "checkout.billingInfo.addressLine2Optional",
      },
      City: {
        defaultMessage: "City",
        id: "checkout.billingInfo.city",
      },
      PostCode: {
        defaultMessage: "Post code",
        id: "checkout.billingInfo.postCode",
      },
      VatNumber: {
        defaultMessage: "VAT number (including country code)",
        id: "checkout.billingInfo.vatNumber",
      },
      TaxId: {
        defaultMessage: "Tax ID (Optional)",
        id: "checkout.billingInfo.taxId",
      },
    },

    // Summary section
    Summary: {
      Title: {
        defaultMessage: "Summary",
        id: "checkout.summary.title",
      },
      Shapr3DPro: {
        defaultMessage: "Shapr3D Pro",
        id: "checkout.summary.shapr3dPro",
      },
      Shapr3DSolo: {
        defaultMessage: "Shapr3D Solo",
        id: "checkout.summary.shapr3dSolo",
      },
      Shapr3DStudio: {
        defaultMessage: "Shapr3D Studio",
        id: "checkout.summary.shapr3dStudio",
      },
      SeatPrice: {
        defaultMessage:
          "{seats} {seats, plural, one {seat} other {seats}} × {symbol}{amount} × {period}",
        id: "checkout.summary.seatPrice",
      },
      OneYear: {
        defaultMessage: "1 year",
        id: "checkout.summary.oneYear",
      },
      OneMonth: {
        defaultMessage: "1 month",
        id: "checkout.summary.oneMonth",
      },
      MigrationDiscount: {
        defaultMessage:
          "You're transitioning from an individual to a team subscription. Your discount offsets what remains from your individual subscription.",
        id: "checkout.summary.migrationDiscount",
      },
      TaxVat: {
        defaultMessage: "Tax (VAT)",
        id: "checkout.summary.taxVat",
      },
      DueOn: {
        defaultMessage: "Due on {date}",
        id: "checkout.summary.dueOn",
      },
      TotalDueToday: {
        defaultMessage: "Total due today",
        id: "checkout.summary.totalDueToday",
      },
      StartFreeTrial: {
        defaultMessage: "Start Free Trial",
        id: "checkout.summary.startFreeTrial",
      },
      CardChargedOnClick: {
        defaultMessage: "Your card will be charged when you click Subscribe now.",
        id: "checkout.summary.cardChargedOnClick",
      },
      TrialEndsOn: {
        defaultMessage: "Your trial ends on {date}. ",
        id: "checkout.summary.trialEndsOn",
      },
      SeatsRenewFullPrice: {
        defaultMessage: "All seats renew at full price. ",
        id: "checkout.summary.seatsRenewFullPrice",
      },
      ChargedPeriodically: {
        defaultMessage: "You will be charged {period} unless you cancel your subscription. ",
        id: "checkout.summary.chargedPeriodically",
      },
      Yearly: {
        defaultMessage: "yearly",
        id: "checkout.summary.yearly",
      },
      Monthly: {
        defaultMessage: "monthly",
        id: "checkout.summary.monthly",
      },
      AllPricesIn: {
        defaultMessage: "All prices in {currency}.",
        id: "checkout.summary.allPricesIn",
      },
    },

    // Coupon
    Coupon: {
      AddCouponCode: {
        defaultMessage: "Add coupon code",
        id: "checkout.coupon.addCouponCode",
      },
      RemoveCouponCode: {
        defaultMessage: "Remove coupon code",
        id: "checkout.coupon.removeCouponCode",
      },
      EnterCode: {
        defaultMessage: "Enter code",
        id: "checkout.coupon.enterCode",
      },
      Apply: {
        defaultMessage: "Apply",
        id: "checkout.coupon.apply",
      },
      InvalidCouponCode: {
        defaultMessage: "Invalid coupon code",
        id: "checkout.coupon.invalidCouponCode",
      },
    },

    // Migration consent
    MigrationConsent: {
      Text: {
        defaultMessage:
          "I understand I need to cancel my App Store subscription to avoid duplicate charges.",
        id: "checkout.migrationConsent.text",
      },
    },

    // Trial timeline
    TrialTimeline: {
      Today: {
        defaultMessage: "Today",
        id: "checkout.trialTimeline.today",
      },
      TodayText: {
        defaultMessage:
          "Add credit card details and get instant access to all features without limits.",
        id: "checkout.trialTimeline.todayText",
      },
      Tomorrow: {
        defaultMessage: "Tomorrow",
        id: "checkout.trialTimeline.tomorrow",
      },
      DayN: {
        defaultMessage: "Day {day}",
        id: "checkout.trialTimeline.dayN",
      },
      ReminderText: {
        defaultMessage: "Get a reminder email that your free trial will end.",
        id: "checkout.trialTimeline.reminderText",
      },
      ChargedText: {
        defaultMessage: "You will be charged. Cancel anytime before.",
        id: "checkout.trialTimeline.chargedText",
      },
    },

    // Error modal
    ErrorModal: {
      Title: {
        defaultMessage: "Checkout error",
        id: "checkout.errorModal.title",
      },
      AlreadyHasSubscription: {
        defaultMessage: "You already have a subscription.",
        id: "checkout.errorModal.alreadyHasSubscription",
      },
      UnsupportedCountry: {
        defaultMessage:
          "Direct subscriptions are not supported in your country. Try subscribing from the Apple App Store instead.",
        id: "checkout.errorModal.unsupportedCountry",
      },
      VerifyEmail: {
        defaultMessage: "Please verify your email address to complete the checkout.",
        id: "checkout.errorModal.verifyEmail",
      },
      ResendVerificationEmail: {
        defaultMessage: "Resend verification email",
        id: "checkout.errorModal.resendVerificationEmail",
      },
      TooManyAttempts: {
        defaultMessage: "Too many attempts",
        id: "checkout.errorModal.tooManyAttempts",
      },
      TryAgainLater: {
        defaultMessage: "Please try again later, or submit a support ticket via",
        id: "checkout.errorModal.tryAgainLater",
      },
      ThisLink: {
        defaultMessage: "this link",
        id: "checkout.errorModal.thisLink",
      },
      TierUnavailable: {
        defaultMessage: "You don't have access to this subscription tier.",
        id: "checkout.errorModal.tierNotAvailable",
      },
    },

    // Validation errors
    ValidationError: {
      Required: {
        defaultMessage: "Required",
        id: "checkout.validationError.required",
      },
      InvalidCvv: {
        defaultMessage: "Invalid CVV number",
        id: "checkout.validationError.invalidCvv",
      },
      InvalidExpiration: {
        defaultMessage: "Invalid expiration date",
        id: "checkout.validationError.invalidExpiration",
      },
      InvalidPostCode: {
        defaultMessage: "Invalid post code",
        id: "checkout.validationError.invalidPostCode",
      },
      InvalidCountry: {
        defaultMessage: "Invalid country",
        id: "checkout.validationError.invalidCountry",
      },
      InvalidState: {
        defaultMessage: "Invalid state",
        id: "checkout.validationError.invalidState",
      },
      InvalidCity: {
        defaultMessage: "Invalid city",
        id: "checkout.validationError.invalidCity",
      },
      InvalidAddress: {
        defaultMessage: "Invalid address",
        id: "checkout.validationError.invalidAddress",
      },
      InvalidVatNumber: {
        defaultMessage: "Invalid VAT number",
        id: "checkout.validationError.invalidVatNumber",
      },
      IncompleteCardNumber: {
        defaultMessage: "Incomplete card number",
        id: "checkout.validationError.incompleteCardNumber",
      },
      InvalidCardNumber: {
        defaultMessage: "Invalid card number",
        id: "checkout.validationError.invalidCardNumber",
      },
    },

    // Payment errors
    PaymentError: {
      ApplePaySetupFailed: {
        defaultMessage:
          "Something went wrong while setting up Apple Pay. Please try again or choose a different payment method.",
        id: "checkout.paymentError.applePaySetupFailed",
      },
      ApplePaySetupFailedTitle: {
        defaultMessage: "Failed to set up Apple Pay",
        id: "checkout.paymentError.applePaySetupFailedTitle",
      },
      PaymentInfoUpdated: {
        defaultMessage: "Payment information updated",
        id: "checkout.paymentError.paymentInfoUpdated",
      },
      DeclinedTitle: {
        defaultMessage: "Payment declined",
        id: "checkout.paymentError.declinedTitle",
      },
      DeclinedDescription: {
        defaultMessage:
          "There is an issue with your card. Please try again or use a different card. If the issue persists, contact your bank.",
        id: "checkout.paymentError.declinedDescription",
      },
      InsufficientFundsTitle: {
        defaultMessage: "Insufficient funds",
        id: "checkout.paymentError.insufficientFundsTitle",
      },
      InsufficientFundsDescription: {
        defaultMessage: "Please check your balance or try a different card.",
        id: "checkout.paymentError.insufficientFundsDescription",
      },
      VerificationFailedTitle: {
        defaultMessage: "Payment verification failed",
        id: "checkout.paymentError.verificationFailedTitle",
      },
      VerificationFailedDescription: {
        defaultMessage:
          "Please try again and follow your bank's verification instructions. If the issue persists, try a different card or contact your bank.",
        id: "checkout.paymentError.verificationFailedDescription",
      },
      CouponInvalidTitle: {
        defaultMessage: "Invalid coupon",
        id: "checkout.paymentError.couponInvalidTitle",
      },
      CouponInvalidDescription: {
        defaultMessage: "The coupon code could not be applied. Please remove it and try again.",
        id: "checkout.paymentError.couponInvalidDescription",
      },
      GenericTitle: {
        defaultMessage: "Payment Error",
        id: "checkout.paymentError.genericTitle",
      },
      GenericDescription: {
        defaultMessage:
          "Please check your details and try again. If the issue persists, try a different card or contact your bank.",
        id: "checkout.paymentError.genericDescription",
      },
    },
  },
  Purchase: {
    Plans: {
      Pro: {
        FeatureDescription: {
          defaultMessage: "Everything in Basic, plus:",
          id: "purchase.plans.pro.feature.description",
        },
        Feature01: {
          defaultMessage: "Teamspace, your centralized collaboration space directly in CAD",
          id: "purchase.plans.pro.feature01",
        },
        Feature02: {
          defaultMessage: "Unlimited designs",
          id: "purchase.plans.pro.feature02",
        },
        Feature03: {
          defaultMessage:
            "Invite up to 2 Contributors per team to share and review team projects with stakeholders",
          id: "purchase.plans.pro.feature03",
        },
        Feature04: {
          defaultMessage: "Export formats for standard CAD files including X_T, X_B, STEP & IGES",
          id: "purchase.plans.pro.feature04",
        },
        Feature05: {
          defaultMessage: "Integrated modeling and Visualization environments, plus AR",
          id: "purchase.plans.pro.feature05",
        },
        Feature06: {
          defaultMessage: "Industry-standard technical drawings",
          id: "purchase.plans.pro.feature06",
        },
        Feature07: {
          defaultMessage: "Priority technical support",
          id: "purchase.plans.pro.feature07",
        },
      },
    },
    PriceMonthlySave: {
      defaultMessage: "Save {savingsPercent}%",
      id: "purchase.priceMonthlySave",
    },
    PricePerSeatPerMonth: {
      defaultMessage: "{price}/seat/month",
      id: "purchase.pricePerSeatPerMonth",
    },
    PricePerMonth: {
      defaultMessage: "{price}/month",
      id: "purchase.pricePerMonth",
    },
    PricePerSeatBilledAnnually: {
      defaultMessage: "{price}/seat {billedAnnually}",
      id: "purchase.pricePerSeatBilledAnnually",
    },
    PriceBilledAnnuallyWithPrice: {
      defaultMessage: "{price} {billedAnnually}",
      id: "purchase.priceBilledAnnuallyWithPrice",
    },
    PriceBilledAnnually: {
      defaultMessage: "Billed annually, excludes tax",
      id: "purchase.billedAnnually",
    },
    PriceBilledAnnuallyIncluding: {
      defaultMessage: "Billed annually, includes tax",
      id: "purchase.billedAnnuallyIncluding",
    },
    PriceBilledMonthly: {
      defaultMessage: "Excludes tax",
      id: "purchase.billedMonthly",
    },
    PriceBilledMonthlyIncluding: {
      defaultMessage: "Includes tax",
      id: "purchase.billedMonthlyIncluding",
    },
  },
  Button: {
    SelectBasic: {
      defaultMessage: "Select Basic",
      id: "button.selectBasic",
      dontTranslate: true,
    },
    Download: {
      defaultMessage: "Download",
      id: "button.download",
    },
    Yearly: {
      defaultMessage: "Yearly",
      id: "button.yearly",
    },
    Monthly: {
      defaultMessage: "Monthly",
      id: "button.monthly",
    },
    ContactUs: {
      defaultMessage: "Contact us",
      id: "button.contactUs",
    },
  },

  ProjectSidebar: {
    AutosaveVersions: {
      defaultMessage: "{count, plural, one {# Autosave Version} other {# Autosave Versions}}",
      id: "projectSidebar.autosaveVersions",
      dontTranslate: true,
    },
  },

  Login: {
    DontHaveAccount: {
      defaultMessage: "Don't have an account?",
      id: "login.dontHaveAccount",
    },
    SignUp: {
      defaultMessage: "Sign up.",
      id: "login.signUp",
    },
    ForgotPassword: {
      defaultMessage: "Forgot password?",
      id: "login.forgotPassword",
    },
  },

  PasswordValidation: {
    HasLowercase: {
      defaultMessage: "1 lowercase character",
      id: "passwordValidation.hasLowercase",
    },
    HasUppercase: {
      defaultMessage: "1 uppercase character",
      id: "passwordValidation.hasUppercase",
    },
    HasNumber: {
      defaultMessage: "1 number",
      id: "passwordValidation.hasNumber",
    },
    MinimumLength: {
      defaultMessage: "12 characters minimum",
      id: "passwordValidation.minimumLength",
    },
  },

  SignUp: {
    CreateAnAccount: {
      defaultMessage: "Create an account",
      id: "signUp.createAnAccount",
    },
    CreateAnAccountMobile: {
      defaultMessage: "Create an account to get started",
      id: "signUp.createAnAccountMobile",
    },
    DownloadSuggestion: {
      defaultMessage: "Then, download Shapr3D for macOS, iPadOS, or Windows to start designing.",
      id: "signUp.downloadSuggestion",
    },
    FirstCreateAnAccount: {
      defaultMessage: "First, create an account",
      id: "signUp.firstCreateAnAccount",
    },
    SendInviteAgain: {
      defaultMessage: "Send invite email again",
      id: "signUp.SendInviteAgain",
    },
    AlreadyHaveAnAccountQuestion: {
      defaultMessage: "Already have an account?",
      id: "signUp.alreadyHaveAnAccountQuestion",
    },
    AgreeTerms: {
      defaultMessage: "I have read, understood and agree to the {termsOfUse} and {privacyPolicy}",
      id: "signup.agreeTerms",
    },
    SignupAndDownload: {
      defaultMessage: "Sign Up to Download",
      id: "signUp.signupAndDownload",
    },
  },

  ResetPassword: {
    Title: {
      defaultMessage: "Reset password",
      id: "resetPassword.title",
    },
    InputPageTitle: {
      defaultMessage: "Reset password",
      id: "resetPassword.inputPageTitle",
    },
    Instructions: {
      defaultMessage:
        "Enter your account email, and we’ll send you a password reset link right away.",
      id: "resetPassword.instructions",
    },
    SendResetLink: {
      defaultMessage: "Send Reset Link",
      id: "resetPassword.sendResetLink",
    },
    BackToLogin: {
      defaultMessage: "Back to Login",
      id: "resetPassword.backToLogin",
    },
    TryAgain: {
      defaultMessage: "Try again",
      id: "resetPassword.tryAgain",
    },
    SendAgain: {
      defaultMessage: "Resend Link",
      id: "resetPassword.sendAgain",
    },
    EmailSent: {
      defaultMessage: "Email sent",
      id: "resetPassword.emailSent",
    },
    ErrorTitle: {
      defaultMessage: "Expired link",
      id: "resetPassword.errorTitle",
    },
    SuccessMessage: {
      defaultMessage: "Your password reset link was sent to this email:",
      id: "resetPassword.successMessage",
    },
    CantFindEmail: {
      defaultMessage: "Can’t find our email? Make sure to check your spam folder.",
      id: "resetPassword.cantFindEmail",
    },
    PasswordUpdated: {
      defaultMessage: "Password updated",
      id: "resetPassword.passwordUpdated",
    },
    SuccessfulResetMessage: {
      defaultMessage: "You’ve successfully updated your password.",
      id: "resetPassword.successfulResetMessage",
    },
    ErrorMessage: {
      defaultMessage: "To reset your password, please try again.",
      id: "resetPassword.errorMessage",
    },
  },

  TwoFactorAuth: {
    Title: {
      defaultMessage: "Let's make sure it's really you",
      id: "twoFactorAuth.title",
    },
    EnterCode: {
      defaultMessage: "Enter the 6-digit verification code from your authenticator app",
      id: "twoFactorAuth.enterCode",
    },
    DontHaveApp: {
      defaultMessage: "Don't have your authenticator app?",
      id: "twoFactorAuth.dontHaveApp",
    },
    Reset2FA: {
      defaultMessage: "Reset 2FA",
      id: "twoFactorAuth.reset2FA",
    },
    EnterRecoveryCode: {
      defaultMessage: "Enter a recovery code to temporarily turn off 2FA and access your account",
      id: "twoFactorAuth.enterRecoveryCode",
    },
    VerificationMinLength: {
      defaultMessage: "Code must be 6 digits",
      id: "twoFactorAuth.verificationMinLength",
    },
    VerificationInvalidCode: {
      defaultMessage: "Invalid verification code.",
      id: "twoFactorAuth.verificationInvalidCode",
    },
    VerificationCode: {
      defaultMessage: "Verification code",
      id: "twoFactorAuth.verificationCode",
    },
    RecoveryCode: {
      defaultMessage: "Recovery code",
      id: "twoFactorAuth.recoveryCode",
    },
    RecoveryCodeRequired: {
      defaultMessage: "Recovery code is required",
      id: "twoFactorAuth.recoveryCodeRequired",
    },
    RecoveryCodeInvalid: {
      defaultMessage: "Invalid recovery code.",
      id: "twoFactorAuth.recoveryCodeInvalid",
    },
    Setup: {
      Title: {
        defaultMessage: "Set up 2FA",
        id: "twoFactorAuth.setup.title",
      },
      Description: {
        defaultMessage:
          "Add an extra layer of protection to your account. When you sign in, you\u2019ll confirm it\u2019s really you by entering a 6-digit code from an authenticator app.",
        id: "twoFactorAuth.setup.description",
      },
      Step1Title: {
        defaultMessage: "Step 1: Scan this code with an authenticator app",
        id: "twoFactorAuth.setup.step1Title",
      },
      Step1Description: {
        defaultMessage:
          "Download an authenticator app like Authy, 1Password, Microsoft Authenticator or Google Authenticator and scan this QR code.",
        id: "twoFactorAuth.setup.step1Description",
      },
      Step2Title: {
        defaultMessage: "Step 2: Enter your Authentication code",
        id: "twoFactorAuth.setup.step2Title",
      },
      Step2Description: {
        defaultMessage: "Enter the 6-digit verification code from your authenticator app.",
        id: "twoFactorAuth.setup.step2Description",
      },
      Cancel: {
        defaultMessage: "Cancel",
        id: "twoFactorAuth.setup.cancel",
      },
      Enable2FA: {
        defaultMessage: "Enable 2FA",
        id: "twoFactorAuth.setup.enable2FA",
      },
      CopyToClipboard: {
        defaultMessage: "Copy to clipboard",
        id: "twoFactorAuth.setup.copyToClipboard",
      },
      SecretCopied: {
        defaultMessage: "Secret key copied to clipboard!",
        id: "twoFactorAuth.setup.secretCopied",
      },
      SecretCopyFailed: {
        defaultMessage: "Failed to copy secret key to clipboard",
        id: "twoFactorAuth.setup.secretCopyFailed",
      },
      ErrorSetupAgain: {
        defaultMessage: "Something went wrong. Please try setting up again.",
        id: "twoFactorAuth.setup.errorSetupAgain",
      },
      InvalidCode: {
        defaultMessage: "Invalid code. Please try again.",
        id: "twoFactorAuth.setup.invalidCode",
      },
      CodeMustBeSixDigits: {
        defaultMessage: "Code must be 6 digits",
        id: "twoFactorAuth.setup.codeMustBeSixDigits",
      },
      AlreadyEnabled: {
        defaultMessage: "Two-factor authentication is already enabled.",
        id: "twoFactorAuth.setup.alreadyEnabled",
      },
    },
    Disable: {
      Title: {
        defaultMessage: "Are you sure you want to disable 2FA?",
        id: "twoFactorAuth.disable.title",
      },
      Description: {
        defaultMessage:
          "Two-factor authentication adds an extra layer of security to your account. Without it, your account is more vulnerable to unauthorized access.",
        id: "twoFactorAuth.disable.description",
      },
      Instruction: {
        defaultMessage: "Enter the 6-digit code from your authenticator app to disable the 2FA",
        id: "twoFactorAuth.disable.instruction",
      },
      DisableAnyway: {
        defaultMessage: "Disable anyway",
        id: "twoFactorAuth.disable.disableAnyway",
      },
      Keep2FAEnabled: {
        defaultMessage: "Keep 2FA enabled",
        id: "twoFactorAuth.disable.keep2FAEnabled",
      },
      ErrorTryAgain: {
        defaultMessage: "Something went wrong. Please try again.",
        id: "twoFactorAuth.disable.errorTryAgain",
      },
      InvalidCode: {
        defaultMessage: "Invalid code. Please try again.",
        id: "twoFactorAuth.disable.invalidCode",
      },
    },
    Recovery: {
      Title: {
        defaultMessage: "Save your recovery code",
        id: "twoFactorAuth.recovery.title",
      },
      Important: {
        defaultMessage: "Important",
        id: "twoFactorAuth.recovery.important",
      },
      SaveDescription: {
        defaultMessage:
          "Save your recovery code in a safe place. It is used to access your account in case you lose access to your device or cannot access your authenticator app for some other reason.",
        id: "twoFactorAuth.recovery.saveDescription",
      },
      SecurityWarning: {
        defaultMessage:
          "For security reasons, we will not be able to help you recover your account without it.",
        id: "twoFactorAuth.recovery.securityWarning",
      },
      CopyToClipboard: {
        defaultMessage: "Copy to clipboard",
        id: "twoFactorAuth.recovery.copyToClipboard",
      },
      DownloadAsTxt: {
        defaultMessage: "Download as .txt",
        id: "twoFactorAuth.recovery.downloadAsTxt",
      },
      CodeCopied: {
        defaultMessage: "Recovery code copied to clipboard!",
        id: "twoFactorAuth.recovery.codeCopied",
      },
      CodeCopyFailed: {
        defaultMessage: "Failed to copy recovery code to clipboard",
        id: "twoFactorAuth.recovery.codeCopyFailed",
      },
      CodeDownloaded: {
        defaultMessage: "Recovery code downloaded as .txt!",
        id: "twoFactorAuth.recovery.codeDownloaded",
      },
      SavedCode: {
        defaultMessage: "I have saved the code",
        id: "twoFactorAuth.recovery.savedCode",
      },
    },
  },

  TeamSelector: {
    MemberCount: {
      id: "teamSelector.memberCount",
      defaultMessage: "{count, plural, one {# member} other {# members}}",
      dontTranslate: true,
    },
    TeamSettings: {
      defaultMessage: "Team settings",
      id: "teamSelector.teamSettings",
    },
    CreateSpace: {
      defaultMessage: "Create space",
      id: "teamSelector.createSpace",
    },
    TeamName: {
      defaultMessage: "Team name",
      id: "teamSelector.teamName",
    },
    EditTeamName: {
      defaultMessage: "Edit team name",
      id: "teamSelector.editTeamName",
    },
    Spaces: {
      defaultMessage: "Spaces",
      id: "teamSelector.spaces",
    },
    RenameSpace: {
      defaultMessage: "Rename space",
      id: "teamSelector.renameSpace",
    },
    CreateNewSpace: {
      defaultMessage: "Create new space",
      id: "teamSelector.createNewSpace",
    },
    SpaceName: {
      defaultMessage: "Space name",
      id: "teamSelector.spaceName",
    },
    SpaceNamePlaceholder: {
      defaultMessage: "e.g. John\u2019s Work, Design Team, Modeling...",
      id: "teamSelector.spaceNamePlaceholder",
    },
    PleaseEnterTeamName: {
      defaultMessage: "Please enter a team name",
      id: "teamSelector.pleaseEnterTeamName",
    },
    PleaseEnterSpaceName: {
      defaultMessage: "Please enter a space name",
      id: "teamSelector.pleaseEnterSpaceName",
    },
    Save: {
      defaultMessage: "Save",
      id: "teamSelector.save",
    },
    Edit: {
      defaultMessage: "Edit",
      id: "teamSelector.edit",
    },
  },

  MembersPage: {
    SelectionMessage: {
      id: "membersPage.SelectionMessage",
      defaultMessage: "{count, plural, one {# member} other {# members}} selected",
      dontTranslate: true,
    },
    Members: {
      defaultMessage: "Members",
      id: "membersPage.members",
    },
    InviteMembers: {
      defaultMessage: "Invite members",
      id: "membersPage.inviteMembers",
    },
    RemoveMember: {
      defaultMessage: "Remove member",
      id: "membersPage.removeMember",
    },
    RemoveInvitation: {
      defaultMessage: "Remove invitation",
      id: "membersPage.removeInvitation",
    },
    TeamPromoAlt: {
      defaultMessage: "Team promo illustration",
      id: "membersPage.teamPromoAlt",
    },
    CollaborateWithTeam: {
      defaultMessage: "Collaborate with your team",
      id: "membersPage.collaborateWithTeam",
    },
    CutOnboarding: {
      defaultMessage: "Cut CAD onboarding time to days for your team",
      id: "membersPage.cutOnboarding",
    },
    CentralizeSharing: {
      defaultMessage: "Centralize design sharing in one synced hub",
      id: "membersPage.centralizeSharing",
    },
    CurateLibrary: {
      defaultMessage: "Curate your team\u2019s part library",
      id: "membersPage.curateLibrary",
    },
    Pending: {
      defaultMessage: "pending",
      id: "membersPage.pending",
    },
    NoMembersMatch: {
      defaultMessage: "No members match your search query. Try your search again.",
      id: "membersPage.noMembersMatch",
    },
    AddToSpace: {
      defaultMessage: "Add to space...",
      id: "membersPage.addToSpace",
    },
    RemoveFromSpace: {
      defaultMessage: "Remove from space...",
      id: "membersPage.removeFromSpace",
    },
    OnlyOwnersCanInvite: {
      defaultMessage: "Only team owners can send invites.",
      id: "membersPage.onlyOwnersCanInvite",
    },
    ContactOwnerToAdd: {
      defaultMessage: "To add new members to {teamName}, contact your team owner.",
      id: "membersPage.contactOwnerToAdd",
    },
    InvitationUnavailable: {
      defaultMessage: "Invitation to {teamName} is unavailable.",
      id: "membersPage.invitationUnavailable",
    },
    TurnOnAutoRenewalToInvite: {
      defaultMessage: "Turn on auto-renewal to invite new members.",
      id: "membersPage.turnOnAutoRenewalToInvite",
    },
    UpdateCardToInvite: {
      defaultMessage: "Update your card details to invite new members.",
      id: "membersPage.updateCardToInvite",
    },
    RemovingMemberText: {
      defaultMessage:
        "Removing <bold>{name}</bold>{emailSuffix} from {teamName} will revoke their access to the team immediately.",
      id: "membersPage.removingMemberText",
    },
    AdditionalSeatText: {
      defaultMessage:
        "Your team will have one additional seat to assign. You can invite new member to that seat anytime.",
      id: "membersPage.additionalSeatText",
    },
    TeamAllSet: {
      defaultMessage: "Your team is now all set!",
      id: "membersPage.teamAllSet",
    },
    TeamAllSetDescription: {
      defaultMessage: "Open Shapr3D and check out your team\u2019s projects in Teamspace!",
      id: "membersPage.teamAllSetDescription",
    },
    DownloadShapr3D: {
      defaultMessage: "Download Shapr3D",
      id: "membersPage.downloadShapr3D",
    },
    InviteAndManage: {
      defaultMessage: "Invite and manage your team\u2019s members",
      id: "membersPage.inviteAndManage",
    },
    GoToMembers: {
      defaultMessage: "Go to members",
      id: "membersPage.goToMembers",
    },
    InviteModalTitle: {
      defaultMessage: "Invite members",
      id: "membersPage.inviteModalTitle",
    },
    Emails: {
      defaultMessage: "Emails",
      id: "membersPage.emails",
    },
    InvitingUnavailable: {
      defaultMessage: "Inviting new members is unavailable.",
      id: "membersPage.invitingUnavailable",
    },
    InvitationUnavailableNow: {
      defaultMessage: "Invitation is unavailable at the moment.",
      id: "membersPage.invitationUnavailableNow",
    },
    InvitationGracePeriodText: {
      defaultMessage:
        "Your subscription is within the grace period. Update your card details to invite new members and buy new seats.",
      id: "membersPage.invitationGracePeriodText",
    },
    InvitationCancelledText: {
      defaultMessage:
        "Your subscription has been canceled. Turn on auto-renewal to invite new members and buy new seats.",
      id: "membersPage.invitationCancelledText",
    },
    InvitationEstimateError: {
      defaultMessage: "Please reload the page or try again later if the issue persists.",
      id: "membersPage.invitationEstimateError",
    },
    InvitationNotAvailableText: {
      defaultMessage: "Click below to learn more how to start collaborating with your team.",
      id: "membersPage.invitationNotAvailableText",
    },
    PaymentErrorInvitation: {
      defaultMessage: "Payment error, invitation failed.",
      id: "membersPage.paymentErrorInvitation",
    },
    UpdateCardToInviteMembers: {
      defaultMessage: "Update your card details to invite members.",
      id: "membersPage.updateCardToInviteMembers",
    },
    UpdateAndInvite: {
      defaultMessage: "Update & invite",
      id: "membersPage.updateAndInvite",
    },
    InvitationSent: {
      defaultMessage: "Invitation successfully sent!",
      id: "membersPage.invitationSent",
    },
    Continue: {
      defaultMessage: "Continue",
      id: "membersPage.continue",
    },
    Invite: {
      defaultMessage: "Invite",
      id: "membersPage.invite",
    },
    AdditionalSeatsAffectPlan: {
      defaultMessage: "Your additional team seats may affect your current plan.",
      id: "membersPage.additionalSeatsAffectPlan",
    },
    TableHeaderMember: {
      defaultMessage: "MEMBER",
      id: "membersPage.tableHeaderMember",
    },
    TableHeaderRole: {
      defaultMessage: "ROLE",
      id: "membersPage.tableHeaderRole",
    },
    TableHeaderSpace: {
      defaultMessage: "SPACE",
      id: "membersPage.tableHeaderSpace",
    },
    ContributorSeatsAssigned: {
      defaultMessage:
        "You\u2019ve assigned all available Contributor seats. You can add up-to {maxContributors} free Contributors to your team.{editorEligible, select, true { You can invite additional members as Editors.} other {}}",
      id: "membersPage.contributorSeatsAssigned",
    },
    InviteAsEditor: {
      defaultMessage: "Invite as Editor...",
      id: "membersPage.inviteAsEditor",
    },
    ContributorDomainRestriction: {
      defaultMessage:
        "The free Contributor role is only available with a company email address. Try a different email address or",
      id: "membersPage.contributorDomainRestriction",
    },
    ChargeOnUpdate: {
      defaultMessage:
        "Your card will get charged {currencySymbol}{amount} when you click \u2018Update & invite\u2019. {allPricesInUSD}",
      id: "membersPage.chargeOnUpdate",
    },
    AllPricesInCurrency: {
      defaultMessage: "All prices in {currencyCode}.",
      id: "membersPage.allPricesInCurrency",
    },
    PricePerSeat: {
      defaultMessage: "{price}/seat",
      id: "membersPage.pricePerSeat",
    },
    EditorsDescription: {
      defaultMessage: "<mark>Editors</mark> enjoy unlimited access to all Shapr3D features.",
      id: "membersPage.editorsDescription",
    },
    EditProjects: {
      defaultMessage: "Edit projects",
      id: "membersPage.editProjects",
    },
    CreateNewProjects: {
      defaultMessage: "Create new projects",
      id: "membersPage.createNewProjects",
    },
    ExportProjects: {
      defaultMessage: "Export projects",
      id: "membersPage.exportProjects",
    },
    DraftProjects: {
      defaultMessage: "Draft projects",
      id: "membersPage.draftProjects",
    },
    Free: {
      defaultMessage: "Free",
      id: "membersPage.free",
    },
    ContributorsDescription: {
      defaultMessage:
        "<mark>Contributors</mark> can view and edit existing team projects with all modeling tools. Can only be claimed with company email invites.",
      id: "membersPage.contributorsDescription",
    },
    UpToTwoProjects: {
      defaultMessage: "Up to 2 projects",
      id: "membersPage.upToTwoProjects",
    },
    CopyLink: {
      defaultMessage: "Copy link",
      id: "membersPage.copyLink",
    },
    Copied: {
      defaultMessage: "Copied!",
      id: "membersPage.copied",
    },
    FilterMembers: {
      defaultMessage: "Filter members by name, email or space",
      id: "membersPage.filterMembers",
    },
  },

  ShareProjectModal: {
    SpaceAccessDescription: {
      id: "shareProjectModal.spaceAccessDescription",
      defaultMessage:
        "{count, plural, one {# person has} other {# people have}} access to this project because they're {count, plural, one {a member} other {members}} of the space where this project lives.",
      dontTranslate: true,
    },
    SpaceAccessDescriptionNoAccess: {
      id: "shareProjectModal.spaceAccessDescriptionNoAccess",
      defaultMessage: "Members of the space where this project lives.",
      dontTranslate: true,
    },
    SpaceAccessLabelPrivate: {
      id: "shareProjectModal.spaceAccessLabelPrivate",
      defaultMessage: "Only people you directly invite",
      dontTranslate: true,
    },
    SpaceAccessLabelWithName: {
      id: "shareProjectModal.spaceAccessLabelWithName",
      defaultMessage: 'Anyone in "{spaceName}"',
      dontTranslate: true,
    },
    SpaceAccessLabelGeneric: {
      id: "shareProjectModal.spaceAccessLabelGeneric",
      defaultMessage: "Anyone in this space",
      dontTranslate: true,
    },
    SpaceAccessLabelNoAccess: {
      id: "shareProjectModal.spaceAccessLabelNoAccess",
      defaultMessage: "{projectName}",
      dontTranslate: true,
    },
  },

  ShareModal: {
    RemoveConfirmationModal: {
      Title: {
        id: "shareModal.removeConfirmationModal.title",
        defaultMessage: `{action, select,
             leave {Leave this {entity}?}
             remove {Remove {entity}?}
             deny {Deny {entity}?}
             other {Remove {entity}?}
           }`,
        dontTranslate: true,
      },
      Description: {
        id: "shareModal.removeConfirmationModal.description",
        defaultMessage: `{action, select,
             leave {You'll leave this {entity} immediately.}
             remove {This {entity} will be removed immediately.}
             deny {This {entity} will be denied immediately.}
             other {This {entity} will be changed immediately.}
           } You can\u2019t undo this action.`,
        dontTranslate: true,
      },
    },
  },

  Paywall: {
    DownloadShaprFile: {
      Owner: {
        Title: {
          defaultMessage: "Subscribe to export Shapr3D",
          id: "paywall.downloadShaprFile.owner.title",
        },
        Description: {
          defaultMessage: "Get instant access to all features without limits.",
          id: "paywall.downloadShaprFile.owner.description",
        },
      },
      NonOwner: {
        Title: {
          defaultMessage: "Your current team plan doesn't include this feature.",
          id: "paywall.downloadShaprFile.nonOwner.title",
        },
        Description: {
          defaultMessage:
            "Contact your team owner to upgrade the subscription and gain access to all features.",
          id: "paywall.downloadShaprFile.nonOwner.description",
        },
      },
    },
    ProjectEditorRole: {
      Owner: {
        Title: {
          defaultMessage: "Subscribe to collaborate on projects",
          id: "paywall.projectEditorRole.owner.title",
        },
        Description: {
          defaultMessage: "Invite others to edit and keep projects up to date.",
          id: "paywall.projectEditorRole.owner.description",
        },
      },
      NonOwner: {
        Title: {
          defaultMessage: "Your current team plan doesn't include this feature.",
          id: "paywall.projectEditorRole.nonOwner.title",
        },
        Description: {
          defaultMessage:
            "Contact your team owner to upgrade the subscription and gain access to all features.",
          id: "paywall.projectEditorRole.nonOwner.description",
        },
      },
    },
  },

  ErrorMessage: {
    InvalidEmail: {
      defaultMessage: "Please enter a valid email address.",
      id: "errorMessage.invalidEmail",
    },
    EmptyName: {
      defaultMessage: "Please enter your name.",
      id: "errorMessage.emptyName",
    },
    InvalidPassword: {
      defaultMessage: "Please enter your password.",
      id: "errorMessage.invalidPassword",
    },
    WeakPassword: {
      defaultMessage: "Please enter a strong password.",
      id: "errorMessage.weakPassword",
    },
    TooLongPassword: {
      defaultMessage: "Password is too long.",
      id: "errorMessage.tooLongPassword",
    },
    PasswordsDontMatch: {
      defaultMessage: "Passwords do not match.",
      id: "errorMessage.passwordsDontMatch",
    },
    NewPasswordsDontMatch: {
      defaultMessage: "New passwords do not match.",
      id: "errorMessage.newPasswordsDontMatch",
    },
    EmailAlreadyUsed: {
      defaultMessage: "This email is already taken. Please log in.",
      id: "errorMessage.emailAlreadyUsed",
    },
    TermsAndPrivacyNotAccepted: {
      defaultMessage: "Please agree to our Terms and Privacy Policy before proceeding.",
      id: "errorMessage.termsAndPrivacyNotAccepted",
    },
    EmailAlreadyInvited: {
      defaultMessage: "Please use the team invite link to register. You can send the invite again.",
      id: "errorMessage.emailAlreadyInvited",
    },
    InvalidEmailOrPassword: {
      defaultMessage: "The email address or password is incorrect.",
      id: "errorMessage.invalidEmailOrPassword",
    },
    RateLimitError: {
      defaultMessage:
        "You tried to log in too many times in a row. Please try again in a few minutes.",
      id: "errorMessage.rateLimit",
    },
    Unknown: {
      defaultMessage: "Something went wrong. Please try again.",
      id: "errorMessage.unknown",
    },
    CaptchaError: {
      defaultMessage: "Something went wrong. Please refresh the page and try again.",
      id: "errorMessage.captchaError",
    },
    PasswordUnchanged: {
      defaultMessage: "The new password must be different from the current one.",
      id: "errorMessage.passwordUnchanged",
      dontTranslate: true,
    },
  },

  UpdateName: {
    HeadingGreeting: {
      defaultMessage: "Welcome back!",
      id: "updateName.headingGreeting",
    },
    TitleExisting: {
      defaultMessage: "Let's update your name",
      id: "updateName.titleExisting",
    },
    TitleNew: {
      defaultMessage: "Let's add your name",
      id: "updateName.titleNew",
    },
    DescriptionExisting: {
      defaultMessage:
        "We've updated our name requirements.\nPlease enter a name using only letters, spaces,\nhyphens (-), or apostrophes (').",
      id: "updateName.descriptionExisting",
    },
    DescriptionEmpty: {
      defaultMessage: "Your account doesn't have a name yet.\nPlease enter your name to continue.",
      id: "updateName.descriptionEmpty",
    },
    InputPlaceholder: {
      defaultMessage: "Your Name",
      id: "updateName.inputPlaceholder",
    },
    Validation: {
      MinLength: {
        defaultMessage: "Name must be at least 1 character long.",
        id: "updateName.validation.minLength",
      },
      MaxLength: {
        defaultMessage: "Name must be at most {max} characters long.",
        id: "updateName.validation.maxLength",
      },
      AllowedCharacters: {
        defaultMessage: "Name can include letters, spaces, hyphens, and apostrophes only.",
        id: "updateName.validation.allowedCharacters",
      },
      StartsWithLetter: {
        defaultMessage: "Name must start with a letter.",
        id: "updateName.validation.startsWithLetter",
      },
      EndsWithLetter: {
        defaultMessage: "Name must end with a letter.",
        id: "updateName.validation.endsWithLetter",
      },
      RepeatedPunctuation: {
        defaultMessage: "Name cannot contain repeated hyphens or apostrophes.",
        id: "updateName.validation.repeatedPunctuation",
      },
    },
  },

  General: {
    WorkEmail: {
      defaultMessage: "Work email",
      id: "general.workEmail",
    },
    Email: {
      defaultMessage: "Email",
      id: "general.email",
    },
    Password: {
      defaultMessage: "Password",
      id: "general.password",
    },
    ReEnterPassword: {
      defaultMessage: "Re-enter password",
      id: "general.reEnterPassword",
    },
    Name: {
      defaultMessage: "Your name",
      id: "general.name",
    },
    Login: {
      defaultMessage: "Log In",
      id: "general.login",
    },
    SignUp: {
      defaultMessage: "Sign Up",
      id: "general.signUp",
    },
    TermsOfUse: {
      defaultMessage: "Terms of Use",
      id: "general.termsOfUse",
    },
    PrivacyPolicy: {
      defaultMessage: "Privacy Policy",
      id: "general.privacyPolicy",
    },
    Continue: {
      defaultMessage: "Continue",
      id: "general.continue",
    },
    Save: {
      defaultMessage: "Save",
      id: "general.save",
    },
  },

  AppAuth: {
    SomethingWentWrong: {
      defaultMessage: "Something went wrong. Please try logging in from the app again.",
      id: "appAuth.somethingWentWrong",
    },
    SurveySuccess: {
      Title: {
        defaultMessage: "Start modeling now.",
        id: "appAuth.surveySuccess.title",
      },
      SubTitle: {
        defaultMessage: "Launch Shapr3D if your browser doesn't redirect.",
        id: "appAuth.surveySuccess.subTitle",
      },
    },
    LoginExpired: {
      defaultMessage: "Your login session has expired.",
      id: "appAuth.loginExpired",
    },
    TryLoginAgain: {
      defaultMessage: "Try logging in again.",
      id: "appAuth.tryLoginAgain",
    },
    BackToLogin: {
      defaultMessage: "Back to Login",
      id: "appAuth.backToLogin",
    },
    OpenInstructions: {
      defaultMessage: "Click {openShapr} on the dialog shown by your browser.",
      id: "appAuth.openInstructions",
    },
    IfYouDontSee: {
      defaultMessage: "If you don't see a dialog, click {launchShapr}",
      id: "appAuth.ifYouDontSee",
    },
    LoggedAs: {
      defaultMessage: "You are currently logged in as:",
      id: "appAuth.loggedAs",
    },
    LoginWithDifferentAccount: {
      defaultMessage: "Log in with a different account",
      id: "appAuth.loginWithDifferentAccount",
    },
    OpenShapr: {
      defaultMessage: "Open Shapr3D",
      id: "appAuth.openShapr",
    },
    LaunchShapr: {
      defaultMessage: "Launch Shapr3D",
      id: "appAuth.launchShapr",
    },
  },

  IntentPage: {
    Title: {
      defaultMessage: "See what makes Shapr3D different",
      id: "intentPage.title",
    },
    Subtitle: {
      defaultMessage:
        "Before you start modeling, explore the capabilities that set Shapr3D apart. Pick any feature to watch first.",
      id: "intentPage.subtitle",
    },
    WatchNote: {
      defaultMessage: "Click on a video to continue",
      id: "intentPage.watchNote",
    },
    Videos: {
      ModelParts: {
        Title: {
          defaultMessage: "Model parts for 3D printing",
          id: "intentPage.videos.modelParts.title",
        },
        Description: {
          defaultMessage: "Skip the slow learning curve of traditional CAD",
          id: "intentPage.videos.modelParts.description",
        },
      },
      ModelAnywhere: {
        Title: {
          defaultMessage: "Model anywhere your team needs to be",
          id: "intentPage.videos.modelAnywhere.title",
        },
        Description: {
          defaultMessage: "Work seamlessly across iPad, Mac, and Windows",
          id: "intentPage.videos.modelAnywhere.description",
        },
      },
      CommunicateDesignIntent: {
        Title: {
          defaultMessage: "Communicate design intent instantly",
          id: "intentPage.videos.communicateDesignIntent.title",
        },
        Description: {
          defaultMessage: "End miscommunication with visual 3D sharing",
          id: "intentPage.videos.communicateDesignIntent.description",
        },
      },
      ReviewEditAR: {
        Title: {
          defaultMessage: "Review and edit designs in AR",
          id: "intentPage.videos.reviewEditAR.title",
        },
        Description: {
          defaultMessage: "Validate designs with less physical prototypes",
          id: "intentPage.videos.reviewEditAR.description",
        },
      },
      GenerativeRender: {
        Title: {
          defaultMessage: "Place your CAD in photorealistic scenes",
          id: "intentPage.videos.generativeRender.title",
        },
        Description: {
          defaultMessage: "Transform models into presentation-ready renders",
          id: "intentPage.videos.generativeRender.description",
        },
      },
      FixCADImport: {
        Title: {
          defaultMessage: "Fix CAD files on the spot",
          id: "intentPage.videos.fixCADImport.title",
        },
        Description: {
          defaultMessage: "Fast edits. No engineering handoff delays",
          id: "intentPage.videos.fixCADImport.description",
        },
      },
    },
    Buttons: {
      Previous: {
        defaultMessage: "Previous",
        id: "intentPage.buttons.previous",
      },
      StartModeling: {
        defaultMessage: "Start modeling",
        id: "intentPage.buttons.startModeling",
      },
      Next: {
        defaultMessage: "Next",
        id: "intentPage.buttons.next",
      },
    },
  },

  SegmentationSurvey: {
    General: {
      Title: {
        defaultMessage: "Let’s tailor your Shapr3D workspace.",
        id: "segmentationSurvey.general.helpUsImproveShapr3D",
      },
      Next: {
        defaultMessage: "Continue",
        id: "segmentationSurvey.general.next",
      },
      Previous: {
        defaultMessage: "Back",
        id: "segmentationSurvey.general.previous",
      },
      ThankYou: {
        defaultMessage: "Thank you",
        id: "segmentationSurvey.general.thankYou",
      },
      YourAnswersWereSubmittedSuccessfully: {
        defaultMessage: "Your answers were submitted successfully.",
        id: "segmentationSurvey.general.yourAnswersWereSubmittedSuccessfully",
      },
      BackToShapr3DApp: {
        defaultMessage: "Back to Shapr3D app",
        id: "segmentationSurvey.general.backToShapr3DApp",
      },
      SomethingWentWrong: {
        defaultMessage: "Something went wrong",
        id: "segmentationSurvey.general.somethingWentWrong",
      },
      SubmittingYourAnswersWereFailed: {
        defaultMessage: "Submitting your answers were failed. Please try again.",
        id: "segmentationSurvey.general.submittingYourAnswersWereFailed",
      },
      Retry: {
        defaultMessage: "Retry",
        id: "segmentationSurvey.general.retry",
      },
      NotSure: {
        defaultMessage: "Not sure",
        id: "segmentationSurvey.general.notSure",
      },
      Other: {
        defaultMessage: "Other",
        id: "segmentationSurvey.general.other",
      },
      None: {
        defaultMessage: "None",
        id: "segmentationSurvey.general.none",
      },
      Submit: {
        defaultMessage: "Submit",
        id: "segmentationSurvey.general.submit",
      },
      PleaseSelect: {
        defaultMessage: "Please select",
        id: "segmentationSurvey.general.pleaseSelect",
      },
      TailorExperience: {
        defaultMessage: "Let\u2019s tailor your Shapr3D experience.",
        id: "segmentationSurvey.general.tailorExperience",
      },
      WhatDoYouUseFor: {
        defaultMessage: "What do you use 3D design for?",
        id: "segmentationSurvey.general.whatDoYouUseFor",
      },
      Work: {
        defaultMessage: "Work",
        id: "segmentationSurvey.general.work",
      },
      Hobby: {
        defaultMessage: "Hobby",
        id: "segmentationSurvey.general.hobby",
      },
      WorkAndHobby: {
        defaultMessage: "Work and hobby",
        id: "segmentationSurvey.general.workAndHobby",
      },
      EducationIntent: {
        defaultMessage: "Education",
        id: "segmentationSurvey.general.educationIntent",
      },
      FirstDesignTool: {
        defaultMessage: "This is my first 3D design tool",
        id: "segmentationSurvey.general.firstDesignTool",
      },
    },
    QuestionOne: {
      WhatKindOfWork: {
        defaultMessage: "What kind of work do you do?",
        id: "segmentationSurvey.questionOne.what_kind_of_work",
      },
      ProductManufacturing: {
        defaultMessage: "Product Manufacturing",
        id: "segmentationSurvey.questionOne.product_manufacturing",
      },
      Architecture: {
        defaultMessage: "Architecture",
        id: "segmentationSurvey.questionOne.architecture",
      },
      MediaAndEntertainment: {
        defaultMessage: "Digital Entertainment",
        id: "segmentationSurvey.questionOne.media_and_entertainment",
      },
      EducationStudentTeacher: {
        defaultMessage: "Student or Educator",
        id: "segmentationSurvey.questionOne.education",
      },
    },
    QuestionTwo: {
      Title: {
        defaultMessage: "What industry do you work in? ",
        id: "progressiveProfiling.questionTwo.title",
      },
      SubTitle: {
        defaultMessage:
          "Companies in these industries are already designing better products with Shapr3D.",
        id: "progressiveProfiling.questionTwo.subTitle",
      },
      Transportation: {
        Title: {
          defaultMessage: "Transportation",
          id: "progressiveProfiling.questionTwo.transportation.title",
        },
        SubTitle: {
          defaultMessage: "Aerospace, Automotive, or Marine",
          id: "progressiveProfiling.questionTwo.transportation.subTitle",
        },
      },
      IndustrialEquipment: {
        Title: {
          defaultMessage: "Industrial Equipment",
          id: "progressiveProfiling.questionTwo.industrialEquipment.title",
        },
        SubTitle: {
          defaultMessage: "Tools, Machinery, or Parts",
          id: "progressiveProfiling.questionTwo.industrialEquipment.subTitle",
        },
      },
      HighTech: {
        Title: {
          defaultMessage: "High Tech",
          id: "progressiveProfiling.questionTwo.highTech.title",
        },
        SubTitle: {
          defaultMessage: "Consumer or Industrial Electronics",
          id: "progressiveProfiling.questionTwo.highTech.subTitle",
        },
      },
      HomeAndLifestyle: {
        Title: {
          defaultMessage: "Home and Lifestyle",
          id: "progressiveProfiling.questionTwo.homeAndLifestyle.title",
        },
        SubTitle: {
          defaultMessage: "Home Appliances, Furniture, or Consumer Goods",
          id: "progressiveProfiling.questionTwo.homeAndLifestyle.subTitle",
        },
      },
      FMCG: {
        Title: {
          defaultMessage: "FMCG",
          id: "progressiveProfiling.questionTwo.fmcg.title",
        },
        SubTitle: {
          defaultMessage: "Fast-moving consumer goods and packaging",
          id: "progressiveProfiling.questionTwo.fmcg.subTitle",
        },
      },
      ConstructionProducts: {
        Title: {
          defaultMessage: "Construction Products",
          id: "progressiveProfiling.questionTwo.constructionProducts.title",
        },
        SubTitle: {
          defaultMessage: "Structural or ornamental products for buildings",
          id: "progressiveProfiling.questionTwo.constructionProducts.subTitle",
        },
      },
      Other: {
        Title: {
          defaultMessage: "Other",
          id: "progressiveProfiling.questionTwo.other.title",
        },
        SubTitle: {
          defaultMessage: "Please specify",
          id: "progressiveProfiling.questionTwo.other.subTitle",
        },
      },
    },
    QuestionThree: {
      Title: {
        defaultMessage: "Which CAD software have you used or currently use?",
        id: "progressiveProfiling.questionThree.title",
      },
      SubTitle: {
        defaultMessage: "Select all that apply.",
        id: "progressiveProfiling.questionThree.subTitle",
      },
      None: {
        defaultMessage: "None",
        id: "segmentationSurvey.questionThree.none",
      },
      Alias: {
        defaultMessage: "Alias",
        id: "segmentationSurvey.questionThree.alias",
        dontTranslate: true,
      },
      Autocad: {
        defaultMessage: "AutoCAD",
        id: "segmentationSurvey.questionThree.autocad",
        dontTranslate: true,
      },
      Catia: {
        defaultMessage: "CATIA",
        id: "segmentationSurvey.questionThree.catia",
        dontTranslate: true,
      },
      Creo: {
        defaultMessage: "Creo",
        id: "segmentationSurvey.questionThree.creo",
        dontTranslate: true,
      },
      Fusion: {
        defaultMessage: "Fusion 360",
        id: "segmentationSurvey.questionThree.fusion",
        dontTranslate: true,
      },
      Inventor: {
        defaultMessage: "Inventor",
        id: "segmentationSurvey.questionThree.inventor",
        dontTranslate: true,
      },
      Onshape: {
        defaultMessage: "Onshape",
        id: "segmentationSurvey.questionThree.onshape",
        dontTranslate: true,
      },
      Shapr3D: {
        defaultMessage: "Shapr3D",
        id: "segmentationSurvey.questionThree.Shapr3D",
        dontTranslate: true,
      },
      Sketchup: {
        defaultMessage: "SketchUp",
        id: "segmentationSurvey.questionThree.sketchup",
        dontTranslate: true,
      },
      Siemens: {
        defaultMessage: "Siemens NX",
        id: "segmentationSurvey.questionThree.siemens",
        dontTranslate: true,
      },
      SolidEdge: {
        defaultMessage: "Solid Edge",
        id: "segmentationSurvey.questionThree.solidEdge",
        dontTranslate: true,
      },
      SolidWorks: {
        defaultMessage: "SOLIDWORKS",
        id: "segmentationSurvey.questionThree.solidWorks",
        dontTranslate: true,
      },
      Rhino: {
        defaultMessage: "Rhino",
        id: "segmentationSurvey.questionThree.rhino",
        dontTranslate: true,
      },
      Other: {
        defaultMessage: "Other",
        id: "segmentationSurvey.questionThree.other",
      },
      ThreedsMax: {
        defaultMessage: "3DS Max",
        id: "segmentationSurvey.questionThree.3dsMax",
        dontTranslate: true,
      },
      Archicad: {
        defaultMessage: "Archicad",
        id: "segmentationSurvey.questionThree.archicad",
        dontTranslate: true,
      },
      Cinema4d: {
        defaultMessage: "Cinema 4D",
        id: "segmentationSurvey.questionThree.cinema4d",
        dontTranslate: true,
      },
      Revit: {
        defaultMessage: "Revit",
        id: "segmentationSurvey.questionThree.revit",
        dontTranslate: true,
      },
      SpaceClaim: {
        defaultMessage: "SpaceClaim",
        id: "segmentationSurvey.questionThree.spaceclaim",
        dontTranslate: true,
      },
      TinkerCad: {
        defaultMessage: "TinkerCAD",
        id: "segmentationSurvey.questionThree.tinkercad",
        dontTranslate: true,
      },
      Plasticity: {
        defaultMessage: "Plasticity",
        id: "segmentationSurvey.questionThree.plasticity",
        dontTranslate: true,
      },
      Maya: {
        defaultMessage: "Maya",
        id: "segmentationSurvey.questionThree.maya",
        dontTranslate: true,
      },
      FreeCad: {
        defaultMessage: "FreeCAD",
        id: "segmentationSurvey.questionThree.freecad",
        dontTranslate: true,
      },
      Vectorworks: {
        defaultMessage: "Vectorworks",
        id: "segmentationSurvey.questionThree.vectorworks",
        dontTranslate: true,
      },
      Blender: {
        defaultMessage: "Blender",
        id: "segmentationSurvey.questionThree.blender",
        dontTranslate: true,
      },
    },
    QuestionCad: {
      PrimaryToolForWork: {
        defaultMessage: "What is your primary 3D design tool for <b>work</b>?",
        id: "segmentationSurvey.questionCad.primaryToolForWork",
      },
      PrimaryToolForHobby: {
        defaultMessage: "What is your primary 3D design tool for <b>hobby</b>?",
        id: "segmentationSurvey.questionCad.primaryToolForHobby",
      },
      PrimaryToolGeneral: {
        defaultMessage: "What is your primary 3D design tool?",
        id: "segmentationSurvey.questionCad.primaryToolGeneral",
      },
    },
    QuestionProficiency: {
      Title: {
        defaultMessage: "How would you describe your 3D design proficiency?",
        id: "segmentationSurvey.questionProficiency.title",
      },
      Basic: {
        defaultMessage: "Basic",
        id: "segmentationSurvey.questionProficiency.basic",
      },
      BasicSubtitle: {
        defaultMessage: "Simple sketches and parts",
        id: "segmentationSurvey.questionProficiency.basicSubtitle",
      },
      Intermediate: {
        defaultMessage: "Intermediate",
        id: "segmentationSurvey.questionProficiency.intermediate",
      },
      IntermediateSubtitle: {
        defaultMessage: "Small mechanism designs",
        id: "segmentationSurvey.questionProficiency.intermediateSubtitle",
      },
      Advanced: {
        defaultMessage: "Advanced",
        id: "segmentationSurvey.questionProficiency.advanced",
      },
      AdvancedSubtitle: {
        defaultMessage: "Complex parametric logic and/or surfaces",
        id: "segmentationSurvey.questionProficiency.advancedSubtitle",
      },
    },
    QuestionFour: {
      Title: {
        defaultMessage: "Which of the following best describe your work?",
        id: "progressiveProfiling.questionFour.title",
      },
      SubTitle: {
        defaultMessage: "Select all that apply.",
        id: "progressiveProfiling.questionFour.subTitle",
      },
      Concepting: {
        Title: {
          defaultMessage: "Concepting",
          id: "progressiveProfiling.questionFour.concepting.title",
        },
        SubTitle: {
          defaultMessage: "Exploring early design options",
          id: "progressiveProfiling.questionFour.concepting.subTitle",
        },
      },
      Communication: {
        Title: {
          defaultMessage: "Communication",
          id: "progressiveProfiling.questionFour.communication.title",
        },
        SubTitle: {
          defaultMessage: "Sharing a design with others",
          id: "progressiveProfiling.questionFour.communication.subTitle",
        },
      },
      Prototyping: {
        Title: {
          defaultMessage: "Prototyping",
          id: "progressiveProfiling.questionFour.prototyping.title",
        },
        SubTitle: {
          defaultMessage: "Designing prototypes to test ideas",
          id: "progressiveProfiling.questionFour.prototyping.subTitle",
        },
      },
      Engineering: {
        Title: {
          defaultMessage: "Engineering",
          id: "progressiveProfiling.questionFour.engineering.title",
        },
        SubTitle: {
          defaultMessage: "Documenting a design for manufacturing",
          id: "progressiveProfiling.questionFour.engineering.subTitle",
        },
      },
      Manufacturing: {
        Title: {
          defaultMessage: "Manufacturing",
          id: "progressiveProfiling.questionFour.manufacturing.title",
        },
        SubTitle: {
          defaultMessage: "Designing manufacturing tools or fixtures",
          id: "progressiveProfiling.questionFour.manufacturing.subTitle",
        },
      },
      Review: {
        Title: {
          defaultMessage: "Review",
          id: "progressiveProfiling.questionFour.review.title",
        },
        SubTitle: {
          defaultMessage: "Opening designs created by others to give feedback",
          id: "progressiveProfiling.questionFour.review.subTitle",
        },
      },
      Other: {
        Title: {
          defaultMessage: "Other",
          id: "progressiveProfiling.questionFour.other.title",
        },
        SubTitle: {
          defaultMessage: "Please specify",
          id: "progressiveProfiling.questionFour.other.subTitle",
        },
      },
    },
    QuestionFive: {
      Title: {
        defaultMessage: "What brings you to Shapr3D today?",
        id: "progressiveProfiling.questionFive.title",
      },
      SubTitle: {
        defaultMessage: "Your choice here won’t change what you can do in Shapr3D.",
        id: "progressiveProfiling.questionFive.subTitle",
      },
      Business: {
        Title: {
          defaultMessage: "Business",
          id: "progressiveProfiling.questionFive.business.title",
        },
        SubTitle: {
          defaultMessage: "My work or business",
          id: "progressiveProfiling.questionFive.business.subTitle",
        },
      },
      Personal: {
        Title: {
          defaultMessage: "Personal",
          id: "progressiveProfiling.questionFive.personal.title",
        },
        SubTitle: {
          defaultMessage: "Hobbies or personal projects",
          id: "progressiveProfiling.questionFive.personal.subTitle",
        },
      },
      School: {
        Title: {
          defaultMessage: "School",
          id: "progressiveProfiling.questionFive.school.title",
        },
        SubTitle: {
          defaultMessage: "A class I attend or teach",
          id: "progressiveProfiling.questionFive.school.subTitle",
        },
      },
      Other: {
        Title: {
          defaultMessage: "Other",
          id: "progressiveProfiling.questionFive.other.title",
        },
        SubTitle: {
          defaultMessage: "Please specify",
          id: "progressiveProfiling.questionFive.other.subTitle",
        },
      },
    },
    QuestionSix: {
      Title: {
        defaultMessage: "Which of these Shapr3D benefits are most relevant to your workflow?",
        id: "progressiveProfiling.questionSix.title",
      },
      SubTitle: {
        defaultMessage: "Select all that apply.",
        id: "progressiveProfiling.questionSix.subTitle",
      },
      Communication: {
        Title: {
          defaultMessage: "Communication",
          id: "progressiveProfiling.questionSix.communication.title",
        },
        SubTitle: {
          defaultMessage: "Easier communication with my team or stakeholders",
          id: "progressiveProfiling.questionSix.communication.subTitle",
        },
      },
      Iterating: {
        Title: {
          defaultMessage: "Iterating",
          id: "progressiveProfiling.questionSix.iterating.title",
        },
        SubTitle: {
          defaultMessage: "Iterate concepts or designs faster",
          id: "progressiveProfiling.questionSix.iterating.subTitle",
        },
      },
      Mobility: {
        Title: {
          defaultMessage: "Mobility",
          id: "progressiveProfiling.questionSix.mobility.title",
        },
        SubTitle: {
          defaultMessage: "Model faster on-the-go with iPad and tablet",
          id: "progressiveProfiling.questionSix.mobility.subTitle",
        },
      },
      QuickOnboarding: {
        Title: {
          defaultMessage: "Quick onboarding",
          id: "progressiveProfiling.questionSix.quickOnboarding.title",
        },
        SubTitle: {
          defaultMessage: "Faster CAD learning for me and my team",
          id: "progressiveProfiling.questionSix.quickOnboarding.subTitle",
        },
      },
      Rendering: {
        Title: {
          defaultMessage: "Rendering",
          id: "progressiveProfiling.questionSix.rendering.title",
        },
        SubTitle: {
          defaultMessage: "Visualize models faster",
          id: "progressiveProfiling.questionSix.rendering.subTitle",
        },
      },
      AR: {
        Title: {
          defaultMessage: "AR",
          id: "progressiveProfiling.questionSix.ar.title",
        },
        SubTitle: {
          defaultMessage: "Design, edit, and finalize models in real-time and space",
          id: "progressiveProfiling.questionSix.ar.subTitle",
        },
      },
      Other: {
        Title: {
          defaultMessage: "Other",
          id: "progressiveProfiling.questionSix.other.title",
        },
        SubTitle: {
          defaultMessage: "Please specify",
          id: "progressiveProfiling.questionTwo.other.subTitle",
        },
      },
    },
    QuestionSeven: {
      Title: {
        defaultMessage: "What’s the size of your organization?",
        id: "progressiveProfiling.questionSeven.title",
      },
      SubTitle: {
        defaultMessage: "Teams of all sizes build great collaborations through Shapr3D.",
        id: "progressiveProfiling.questionSeven.subTitle",
      },
      JustMe: {
        defaultMessage: "Just me",
        id: "progressiveProfiling.questionSeven.justMe",
      },
      First: {
        defaultMessage: "2-50 people",
        id: "progressiveProfiling.questionSeven.first",
      },
      Second: {
        defaultMessage: "51-250 people",
        id: "progressiveProfiling.questionSeven.second",
      },
      Third: {
        defaultMessage: "251-1,000 people",
        id: "progressiveProfiling.questionSeven.third",
      },
      Fourth: {
        defaultMessage: "1,001-10,000 people",
        id: "progressiveProfiling.questionSeven.fourth",
      },
      Fifth: {
        defaultMessage: "Over 10,000 people",
        id: "progressiveProfiling.questionSeven.fifth",
      },
    },
  },

  ProgressiveProfiling: {
    General: {
      HelpUsImproveShapr3D: {
        defaultMessage: "Help us improve Shapr3D",
        id: "progressiveProfiling.general.helpUsImproveShapr3D",
      },
      Next: {
        defaultMessage: "Next",
        id: "progressiveProfiling.general.next",
      },
      Previous: {
        defaultMessage: "Previous",
        id: "progressiveProfiling.general.previous",
      },
      ThankYou: {
        defaultMessage: "Thank you",
        id: "progressiveProfiling.general.thankYou",
      },
      YourAnswersWereSubmittedSuccessfully: {
        defaultMessage: "Your answers were submitted successfully.",
        id: "progressiveProfiling.general.yourAnswersWereSubmittedSuccessfully",
      },
      BackToShapr3DApp: {
        defaultMessage: "Back to Shapr3D app",
        id: "progressiveProfiling.general.backToShapr3DApp",
      },
      SomethingWentWrong: {
        defaultMessage: "Something went wrong",
        id: "progressiveProfiling.general.somethingWentWrong",
      },
      SubmittingYourAnswersWereFailed: {
        defaultMessage: "Submitting your answers were failed. Please try again.",
        id: "progressiveProfiling.general.submittingYourAnswersWereFailed",
      },
      Retry: {
        defaultMessage: "Retry",
        id: "progressiveProfiling.general.retry",
      },
      NotSure: {
        defaultMessage: "Not sure",
        id: "progressiveProfiling.general.notSure",
      },
      Other: {
        defaultMessage: "Other",
        id: "progressiveProfiling.general.other",
      },
      None: {
        defaultMessage: "None",
        id: "progressiveProfiling.general.none",
      },
      Submit: {
        defaultMessage: "Submit",
        id: "progressiveProfiling.general.submit",
      },
      PleaseSelect: {
        defaultMessage: "Please select",
        id: "progressiveProfiling.general.pleaseSelect",
      },
    },
    QuestionOne: {
      WhichIndustryDoYouWorkIn: {
        defaultMessage: "Which industry do you work in? ",
        id: "progressiveProfiling.questionOne.whichIndustryDoYouWorkIn",
      },
      IndustrialEquipment: {
        defaultMessage: "Industrial Equipment",
        id: "progressiveProfiling.questionOne.industrial_equipment",
      },
      Construction: {
        defaultMessage: "Construction",
        id: "progressiveProfiling.questionOne.construction",
      },
      Architecture: {
        defaultMessage: "Architecture",
        id: "progressiveProfiling.questionOne.architecture",
      },
      FurnitureAndInteriorDesign: {
        defaultMessage: "Furniture & Interior Design",
        id: "progressiveProfiling.questionOne.furniture_and_interior_design",
      },
      HomeAndLifestyle: {
        defaultMessage: "Home & Lifestyle",
        id: "progressiveProfiling.questionOne.home_and_lifestyle",
      },
      ConsumerElectronics: {
        defaultMessage: "Consumer Electronics",
        id: "progressiveProfiling.questionOne.consumer_electronics",
      },
      LifeSciencesAndHealthcare: {
        defaultMessage: "Life Sciences & Healthcare",
        id: "progressiveProfiling.questionOne.life_sciences_and_healthcare",
      },
      TransportationAutomotiveAerospaceMarine: {
        defaultMessage: "Transportation (Automotive, Aerospace, Marine)",
        id: "progressiveProfiling.questionOne.transportationAutomotiveAerospaceMarine",
      },
      MediaAndEntertainment: {
        defaultMessage: "Media & Entertainment",
        id: "progressiveProfiling.questionOne.media_and_entertainment",
      },
      EducationStudentTeacher: {
        defaultMessage: "Education (Student, Teacher)",
        id: "progressiveProfiling.questionOne.education",
      },
    },
    QuestionTwo: {
      HowManyPeopleCreateAndModify3DDesignsInYourCompany: {
        defaultMessage: "How many people create and modify 3D designs in your company?",
        id: "progressiveProfiling.questionTwo.howManyPeopleCreateAndModify3DDesignsInYourCompany",
      },
    },
    QuestionThree: {
      HowManyPeopleOnlyView3DDesignsInYourCompany: {
        defaultMessage: "How many people only view 3D designs in your company?",
        id: "progressiveProfiling.questionThree.howManyPeopleOnlyView3DDesignsInYourCompany",
      },
    },
    QuestionFour: {
      WhatMainMethodDoesYourCompanyUseToStoreDesigns: {
        defaultMessage: "What main method does your company use to store designs?",
        id: "progressiveProfiling.questionFour.whatMainMethodDoesYourCompanyUseToStoreDesigns",
      },
      NoSpecificMethod: {
        defaultMessage: "No specific method",
        id: "progressiveProfiling.questionFour.no_method",
      },
      GeneralCloudServices: {
        defaultMessage: "General cloud services (e.g. Dropbox, Google Drive)",
        id: "progressiveProfiling.questionFour.general_cloud_services",
      },
      OwnServers: {
        defaultMessage: "Own servers",
        id: "progressiveProfiling.questionFour.own_servers",
      },
      PdmPlmSystems: {
        defaultMessage:
          "PDM / PLM systems (e.g. Windchill, SOLIDWORKS PDM, Autodesk Vault, Teamcenter)",
        id: "progressiveProfiling.questionFour.pdm_plm",
      },
    },
    QuestionFive: {
      WhatIsTheMain2D3DDesignToolUsedAtYourCompany: {
        defaultMessage: "What is the main 2D / 3D design tool used at your company?",
        id: "progressiveProfiling.questionFive.whatIsTheMain2D3DDesignToolUsedAtYourCompany",
      },
    },
    QuestionSix: {
      WhichOfTheseRolesDescribesYouTheBestWithinTheCompany: {
        defaultMessage: "Which of these roles describes you the best within the company?",
        id: "progressiveProfiling.questionSix.whichOfTheseRolesDescribesYouTheBestWithinTheCompany",
      },
      IndustrialDesigner: {
        defaultMessage: "Industrial Designer",
        id: "progressiveProfiling.questionSix.industrial_designer",
      },
      EngineerResearchAndDevelopment: {
        defaultMessage: "Engineer (Research & Development)",
        id: "progressiveProfiling.questionSix.engineer_research_and_development",
      },
      EngineerToolDesign: {
        defaultMessage: "Engineer (Tool Design)",
        id: "progressiveProfiling.questionSix.engineer_tool_design",
      },
      TeamLeadEngineerDesign: {
        defaultMessage: "Team Lead (Engineer, Design)",
        id: "progressiveProfiling.questionSix.team_lead",
      },
      TechnicianMachinistOperator: {
        defaultMessage: "Technician / Machinist / Operator",
        id: "progressiveProfiling.questionSix.technician_machinist_operator",
      },
      QualityEngineer: {
        defaultMessage: "Quality Engineer",
        id: "progressiveProfiling.questionSix.quality_engineer",
      },
      TestEngineer: {
        defaultMessage: "Test Engineer",
        id: "progressiveProfiling.questionSix.test_engineer",
      },
      ProductManager: {
        defaultMessage: "Product Manager",
        id: "progressiveProfiling.questionSix.product_manager",
      },
      SalesPurchasing: {
        defaultMessage: "Sales, Purchasing",
        id: "progressiveProfiling.questionSix.sales_purchasing",
      },
      EntrepreneurOwner: {
        defaultMessage: "Entrepreneur / Owner",
        id: "progressiveProfiling.questionSix.entrepreneur_owner",
      },
      CEOLeadershipRole: {
        defaultMessage: "CEO / Leadership role",
        id: "progressiveProfiling.questionSix.ceo_leadership",
      },
    },
  },

  LinkedPersonalAccount: {
    // Modal
    ModalTitle: {
      defaultMessage: "Link personal account",
      id: "linkedPersonalAccount.modalTitle",
    },
    ModalDescription: {
      defaultMessage:
        "Enter the email of your existing personal Shapr3D account below to get a complimentary 1-year subscription.",
      id: "linkedPersonalAccount.modalDescription",
    },
    TeamSelectorLabel: {
      defaultMessage: "Associated team",
      id: "linkedPersonalAccount.teamSelectorLabel",
    },
    EmailPlaceholder: {
      defaultMessage: "Personal email address",
      id: "linkedPersonalAccount.emailPlaceholder",
    },
    ConfirmationText: {
      defaultMessage:
        "This is a one-time action. To confirm you have entered the correct email address, please type CONFIRM below.",
      id: "linkedPersonalAccount.confirmationText",
    },
    ConfirmationPlaceholder: {
      defaultMessage: "Type CONFIRM",
      id: "linkedPersonalAccount.confirmationPlaceholder",
    },
    SubmitButton: {
      defaultMessage: "Link account",
      id: "linkedPersonalAccount.submitButton",
    },
    CloseButton: {
      defaultMessage: "Close",
      id: "linkedPersonalAccount.closeButton",
    },

    // Validation errors
    ValidationEmailRequired: {
      defaultMessage: "Please enter an email address",
      id: "linkedPersonalAccount.validationEmailRequired",
    },
    ValidationEmailInvalid: {
      defaultMessage: "Invalid email",
      id: "linkedPersonalAccount.validationEmailInvalid",
    },
    ValidationSameDomain: {
      defaultMessage: "Personal email cannot be from the same domain as your work email.",
      id: "linkedPersonalAccount.validationSameDomain",
    },
    ValidationConfirmationRequired: {
      defaultMessage: 'Please type "CONFIRM" to proceed',
      id: "linkedPersonalAccount.validationConfirmationRequired",
    },

    // API error messages
    ErrorUserNotInSalesTeam: {
      defaultMessage:
        "You must be a member of a team that has an active enterprise subscription to link a personal account.",
      id: "linkedPersonalAccount.errorUserNotInSalesTeam",
    },
    ErrorInvalidTeamSelection: {
      defaultMessage: "The selected team is not valid.",
      id: "linkedPersonalAccount.errorInvalidTeamSelection",
    },
    ErrorPersonalAccountAlreadyLinked: {
      defaultMessage: "You have already linked a personal account.",
      id: "linkedPersonalAccount.errorPersonalAccountAlreadyLinked",
    },
    ErrorEmailAlreadyLinked: {
      defaultMessage: "This email is already linked to another account.",
      id: "linkedPersonalAccount.errorEmailAlreadyLinked",
    },
    ErrorTargetHasActiveSubscription: {
      defaultMessage: "This account already has an active subscription.",
      id: "linkedPersonalAccount.errorTargetHasActiveSubscription",
    },
    ErrorSameDomainAsSalesAccount: {
      defaultMessage: "Personal email cannot be from the same domain as your work email.",
      id: "linkedPersonalAccount.errorSameDomainAsSalesAccount",
    },
    ErrorEmailNotPersonalDomain: {
      defaultMessage: "Please use a personal email address.",
      id: "linkedPersonalAccount.errorEmailNotPersonalDomain",
    },
    ErrorInvalidEmailFormat: {
      defaultMessage: "Please enter a valid email address.",
      id: "linkedPersonalAccount.errorInvalidEmailFormat",
    },
    ErrorPersonalAccountNotFound: {
      defaultMessage: "No Shapr3D account found. Please create an account first.",
      id: "linkedPersonalAccount.errorPersonalAccountNotFound",
    },
    ErrorGeneric: {
      defaultMessage: "Something went wrong. Please try again.",
      id: "linkedPersonalAccount.errorGeneric",
    },
  },
  PricingCards: {
    Category: {
      Projects: { id: "pricingCards.category.projects", defaultMessage: "Projects" },
      Storage: { id: "pricingCards.category.storage", defaultMessage: "Storage" },
      Import: { id: "pricingCards.category.import", defaultMessage: "Import" },
      Export: { id: "pricingCards.category.export", defaultMessage: "Export" },
      GenerativeTools: {
        id: "pricingCards.category.generativeTools",
        defaultMessage: "Generative Tools",
      },
      CollaborationDocumentation: {
        id: "pricingCards.category.collaborationDocumentation",
        defaultMessage: "Collaboration & Documentation",
      },
      SupportTraining: {
        id: "pricingCards.category.supportTraining",
        defaultMessage: "Support & Training",
      },
      SecurityCompliance: {
        id: "pricingCards.category.securityCompliance",
        defaultMessage: "Security & Compliance",
      },
    },
    AvailableSeatTypes: {
      id: "pricingCards.availableSeatTypes",
      defaultMessage: "Available seat types",
    },
    Seats: {
      TwoContributor: {
        BeforeMark: { id: "pricingCards.seats.twoContributor.beforeMark", defaultMessage: "2 " },
        Mark: { id: "pricingCards.seats.twoContributor.mark", defaultMessage: "Contributor" },
        AfterMark: { id: "pricingCards.seats.twoContributor.afterMark", defaultMessage: " seats" },
      },
      UpToTenEditor: {
        BeforeMark: {
          id: "pricingCards.seats.upToTenEditor.beforeMark",
          defaultMessage: "Up to 10 ",
        },
        Mark: { id: "pricingCards.seats.upToTenEditor.mark", defaultMessage: "Editor" },
        AfterMark: { id: "pricingCards.seats.upToTenEditor.afterMark", defaultMessage: " seats" },
      },
      UnlimitedEditor: {
        BeforeMark: {
          id: "pricingCards.seats.unlimitedEditor.beforeMark",
          defaultMessage: "Unlimited ",
        },
        Mark: { id: "pricingCards.seats.unlimitedEditor.mark", defaultMessage: "Editor" },
        AfterMark: { id: "pricingCards.seats.unlimitedEditor.afterMark", defaultMessage: " seats" },
      },
      SeatManager: {
        Line: { id: "pricingCards.seats.seatManager", defaultMessage: "Seat manager" },
      },
    },
    Free: {
      PlanName: { id: "pricingCards.free.planName", defaultMessage: "Free" },
      Tagline: { id: "pricingCards.free.tagline", defaultMessage: "Your Current Plan" },
      Feature: {
        UpTo2Projects: {
          id: "pricingCards.free.feature.upTo2Projects",
          defaultMessage: "2 projects",
        },
        Platforms: {
          id: "pricingCards.free.feature.platforms",
          defaultMessage: "macOS, iPadOS, Windows and visionOS",
        },
        CloudStorage: {
          id: "pricingCards.free.feature.cloudStorage",
          defaultMessage: "Cloud storage",
        },
        ImportFormats: {
          id: "pricingCards.free.feature.importFormats",
          defaultMessage: "XT, STEP, IGES, DWG, STL",
        },
        ImportSolidworks: {
          id: "pricingCards.free.feature.importSolidworks",
          defaultMessage: "SOLIDWORKS",
        },
        ImportImages: { id: "pricingCards.free.feature.importImages", defaultMessage: "Images" },
        ExportFormats: {
          id: "pricingCards.free.feature.exportFormats",
          defaultMessage: "Basic quality 3MF, STL",
        },
        GenerativeRenders: {
          id: "pricingCards.free.feature.generativeRenders",
          defaultMessage: "20 generations",
        },
        Support: {
          id: "pricingCards.free.feature.support",
          defaultMessage: "Basic technical support",
        },
      },
    },
    Individual: {
      PlanName: { id: "pricingCards.individual.planName", defaultMessage: "Solo" },
      Tagline: { id: "pricingCards.individual.tagline", defaultMessage: "Everything in Free plus" },
      Feature: {
        UpTo100Projects: {
          id: "pricingCards.individual.feature.upTo100Projects",
          defaultMessage: "100 projects",
        },
        VersionHistory: {
          id: "pricingCards.individual.feature.versionHistory",
          defaultMessage: "Version retention up to 1 year",
        },
        CentralizedCloudStorage: {
          id: "pricingCards.individual.feature.centralizedCloudStorage",
          defaultMessage: "Centralized cloud storage",
        },
        ExportShapr3D: {
          id: "pricingCards.individual.feature.exportShapr3D",
          defaultMessage: "Shapr3D",
        },
        ExportHighQualityMeshes: {
          id: "pricingCards.individual.feature.exportHighQualityMeshes",
          defaultMessage: "High quality 3MF, STL",
        },
        ExportStepIges: {
          id: "pricingCards.individual.feature.exportStepIges",
          defaultMessage: "STEP, IGES",
        },
        ExportDxfGroup: {
          id: "pricingCards.individual.feature.exportDxfGroup",
          defaultMessage: "DXF, DWG, SVG, PDF",
        },
        ExportUsdGroup: {
          id: "pricingCards.individual.feature.exportUsdGroup",
          defaultMessage: "USDZ, GLB, OBJ",
        },
        GenerativeRenders: {
          id: "pricingCards.individual.feature.generativeRenders",
          defaultMessage: "100 generations/month",
        },
        TechnicalDrawings: {
          id: "pricingCards.individual.feature.technicalDrawings",
          defaultMessage: "Technical drawings for straightforward manufacturing hand-offs",
        },
        RealtimeRenders: {
          id: "pricingCards.individual.feature.realtimeRenders",
          defaultMessage: "Real-time renders with 100+ materials",
        },
        AR: {
          id: "pricingCards.individual.feature.ar",
          defaultMessage: "Integrated AR on iPad for instant digital prototyping",
        },
        ShareLinks: {
          id: "pricingCards.individual.feature.shareLinks",
          defaultMessage: "Secure links for sharing 3D models, AR preview, and technical drawings",
        },
        Support: {
          id: "pricingCards.individual.feature.support",
          defaultMessage: "Priority technical support",
        },
      },
    },
    Studio: {
      PlanName: { id: "pricingCards.studio.planName", defaultMessage: "Studio" },
      Tagline: { id: "pricingCards.studio.tagline", defaultMessage: "Everything in Solo plus" },
      PriceSubline: { id: "pricingCards.studio.priceSubline", defaultMessage: "per Editor" },
      Feature: {
        UnlimitedProjects: {
          id: "pricingCards.studio.feature.unlimitedProjects",
          defaultMessage: "Unlimited projects",
        },
        UnlimitedTeamspaces: {
          id: "pricingCards.studio.feature.unlimitedTeamspaces",
          defaultMessage: "Unlimited teamspaces",
        },
        VersionHistory: {
          id: "pricingCards.studio.feature.versionHistory",
          defaultMessage: "Version retention up to 3 years",
        },
        DataOwnership: {
          id: "pricingCards.studio.feature.dataOwnership",
          defaultMessage: "Company ownership of all data",
        },
        CentralizedCloudStorage: {
          id: "pricingCards.studio.feature.centralizedCloudStorage",
          defaultMessage: "Centralized cloud storage",
        },
        ImportUsdcJt: {
          id: "pricingCards.studio.feature.importUsdcJt",
          defaultMessage: "USDC, JT",
        },
        ImportCadFormats: {
          id: "pricingCards.studio.feature.importCadFormats",
          defaultMessage: "Catia (V5), NX, Creo, Solid Edge",
        },
        ImportImages: { id: "pricingCards.studio.feature.importImages", defaultMessage: "Images" },
        ExportJt: { id: "pricingCards.studio.feature.exportJt", defaultMessage: "JT" },
        ExportXt: { id: "pricingCards.studio.feature.exportXt", defaultMessage: "X_T, X_B" },
        GenerativeRenders: {
          id: "pricingCards.studio.feature.generativeRenders",
          defaultMessage: "1000 generations/month",
        },
        MaterialLibraries: {
          id: "pricingCards.studio.feature.materialLibraries",
          defaultMessage: "Custom material libraries for consistent brand presentations",
        },
        VisionPro: {
          id: "pricingCards.studio.feature.visionPro",
          defaultMessage: "Vision Pro for individual, immersive design sessions",
        },
        Support: {
          id: "pricingCards.studio.feature.support",
          defaultMessage: "Priority technical support",
        },
      },
    },
    Enterprise: {
      PlanName: { id: "pricingCards.enterprise.planName", defaultMessage: "Enterprise" },
      Tagline: {
        id: "pricingCards.enterprise.tagline",
        defaultMessage: "Everything in Studio plus",
      },
      Feature: {
        UnlimitedProjects: {
          id: "pricingCards.enterprise.feature.unlimitedProjects",
          defaultMessage: "Unlimited projects",
        },
        UnlimitedTeamsTeamspaces: {
          id: "pricingCards.enterprise.feature.unlimitedTeamsTeamspaces",
          defaultMessage: "Unlimited teams and teamspaces",
        },
        VersionHistory: {
          id: "pricingCards.enterprise.feature.versionHistory",
          defaultMessage: "Unlimited version retention",
        },
        DataOwnership: {
          id: "pricingCards.enterprise.feature.dataOwnership",
          defaultMessage: "Company ownership of all data",
        },
        DataStorage: {
          id: "pricingCards.enterprise.feature.dataStorage",
          defaultMessage: "Flexible data storage options:",
        },
        DataStorageSingleTenant: {
          id: "pricingCards.enterprise.feature.dataStorage.singleTenant",
          defaultMessage: "Single tenant",
        },
        DataStoragePrivateCloud: {
          id: "pricingCards.enterprise.feature.dataStorage.privateCloud",
          defaultMessage: "Private cloud",
        },
        DataStorageOnPremise: {
          id: "pricingCards.enterprise.feature.dataStorage.onPremise",
          defaultMessage: "On-premises",
        },
        DataStorageCloudOff: {
          id: "pricingCards.enterprise.feature.dataStorage.cloudOff",
          defaultMessage: "Cloud off",
        },
        ImportCustom: {
          id: "pricingCards.enterprise.feature.importCustom",
          defaultMessage: "Custom import options",
        },
        ExportCustom: {
          id: "pricingCards.enterprise.feature.exportCustom",
          defaultMessage: "Custom export options",
        },
        GenerativeRenders: {
          id: "pricingCards.enterprise.feature.generativeRenders",
          defaultMessage: "Unlimited generations",
        },
        VisionPro: {
          id: "pricingCards.enterprise.feature.visionPro",
          defaultMessage: "Vision Pro for immersive design reviews in XR\u2013even remotely",
        },
        Onboarding: {
          id: "pricingCards.enterprise.feature.onboarding",
          defaultMessage: "Accelerated onboarding & dedicated account manager",
        },
        SecurityCompliance: {
          id: "pricingCards.enterprise.feature.securityCompliance",
          defaultMessage: "ISO 27001 & SOC 2",
        },
      },
    },
  },

  PaddleBillingCheckout: {
    Title: {
      defaultMessage: "Get Shapr3D Pro",
      id: "paddleBillingCheckout.title",
    },
    Subtitle: {
      defaultMessage:
        "Unlock unlimited features for the duration of your plan. No recurring charges.",
      id: "paddleBillingCheckout.subtitle",
    },
    ErrorTitle: {
      defaultMessage: "Something went wrong",
      id: "paddleBillingCheckout.errorTitle",
    },
    ErrorDescription: {
      defaultMessage: "Failed to load payment provider. Please try again later.",
      id: "paddleBillingCheckout.errorDescription",
    },
    BillingPeriod: {
      defaultMessage: "Billing Period",
      id: "paddleBillingCheckout.billingPeriod",
    },
    OneYear: {
      defaultMessage: "1 Year",
      id: "paddleBillingCheckout.oneYear",
    },
    OneMonth: {
      defaultMessage: "1 Month",
      id: "paddleBillingCheckout.oneMonth",
    },
    SavePercent: {
      defaultMessage: "- Save {savingsPercent}%",
      id: "paddleBillingCheckout.savePercent",
    },
    LimitedOffer: {
      defaultMessage: "Limited Offer",
      id: "paddleBillingCheckout.limitedOffer",
    },
    Vat: {
      defaultMessage: "VAT",
      id: "paddleBillingCheckout.vat",
    },
    AutoExpireYear: {
      defaultMessage: "Your subscription will automatically expire in one year.",
      id: "paddleBillingCheckout.autoExpireYear",
    },
    AutoExpireMonth: {
      defaultMessage: "Your subscription will automatically expire in one month.",
      id: "paddleBillingCheckout.autoExpireMonth",
    },
    Summary: {
      defaultMessage: "Summary",
      id: "paddleBillingCheckout.summary",
    },
    TotalDueToday: {
      defaultMessage: "Total due today",
      id: "paddleBillingCheckout.totalDueToday",
    },
    PaymentMethod: {
      defaultMessage: "Payment method",
      id: "paddleBillingCheckout.paymentMethod",
    },
  },

  PaddleBillingPaymentSuccessPage: {
    Title: {
      defaultMessage: "Purchase successful",
      id: "paddleBillingPaymentSuccessPage.title",
    },
    Description: {
      defaultMessage: "Your payment is complete. Download Shapr3D to start modeling.",
      id: "paddleBillingPaymentSuccessPage.description",
    },
    DownloadCTA: {
      defaultMessage: "Download Shapr3D",
      id: "paddleBillingPaymentSuccessPage.downloadCta",
    },
    AlreadyInstalled: {
      defaultMessage: "Already have Shapr3D installed?",
      id: "paddleBillingPaymentSuccessPage.alreadyInstalled",
    },
    OpenApp: {
      defaultMessage: "Open Shapr3D",
      id: "paddleBillingPaymentSuccessPage.openApp",
    },
  },

  TeamBilling: {
    Title: {
      defaultMessage: "Billing",
      id: "teamBilling.title",
    },
    BillingDetails: {
      defaultMessage: "Billing details",
      id: "teamBilling.billingDetails",
    },
    NoBillingDetails: {
      defaultMessage: "No billing details",
      id: "teamBilling.noBillingDetails",
    },
    VatNumber: {
      defaultMessage: "VAT number:",
      id: "teamBilling.vatNumber",
    },
    TaxId: {
      defaultMessage: "Tax ID:",
      id: "teamBilling.taxId",
    },
    PaymentInformation: {
      defaultMessage: "Payment information",
      id: "teamBilling.paymentInformation",
    },
    NoPaymentInfo: {
      defaultMessage: "No payment information available. Please try again later.",
      id: "teamBilling.noPaymentInfo",
    },
    Edit: {
      defaultMessage: "Edit",
      id: "teamBilling.edit",
    },
    EditBillingDetails: {
      defaultMessage: "Edit billing details",
      id: "teamBilling.editBillingDetails",
    },
    NameOnBill: {
      defaultMessage: "Name on the bill",
      id: "teamBilling.nameOnBill",
    },
    AddressLine1: {
      defaultMessage: "Address Line 1",
      id: "teamBilling.addressLine1",
    },
    AddressLine2: {
      defaultMessage: "Address Line 2",
      id: "teamBilling.addressLine2",
    },
    City: {
      defaultMessage: "City",
      id: "teamBilling.city",
    },
    PostCode: {
      defaultMessage: "Post code",
      id: "teamBilling.postCode",
    },
    BillingAddressIssue: {
      defaultMessage: "Billing address issue",
      id: "teamBilling.billingAddressIssue",
    },
    UpdatingUnavailable: {
      defaultMessage: "Updating billing address is unavailable at the moment",
      id: "teamBilling.updatingUnavailable",
    },
    Save: {
      defaultMessage: "Save",
      id: "teamBilling.save",
    },
    InvalidVatCountryCode: {
      defaultMessage: "Invalid VAT number - Please include your country code",
      id: "teamBilling.invalidVatCountryCode",
    },
    SomethingWentWrong: {
      defaultMessage: "Something went wrong.",
      id: "teamBilling.somethingWentWrong",
    },
    InvalidName: {
      defaultMessage: "Invalid name",
      id: "teamBilling.invalidName",
    },
    InvalidAddress: {
      defaultMessage: "Invalid address",
      id: "teamBilling.invalidAddress",
    },
    InvalidCity: {
      defaultMessage: "Invalid city",
      id: "teamBilling.invalidCity",
    },
    InvalidCountry: {
      defaultMessage: "Invalid country",
      id: "teamBilling.invalidCountry",
    },
    InvalidPostCode: {
      defaultMessage: "Invalid post code",
      id: "teamBilling.invalidPostCode",
    },
    InvalidState: {
      defaultMessage: "Invalid state",
      id: "teamBilling.invalidState",
    },
    InvalidVatNumber: {
      defaultMessage: "Invalid VAT number",
      id: "teamBilling.invalidVatNumber",
    },
    VatNumberPlaceholder: {
      defaultMessage: "VAT number (including country code)",
      id: "teamBilling.vatNumberPlaceholder",
    },
    TaxIdPlaceholder: {
      defaultMessage: "Tax ID",
      id: "teamBilling.taxIdPlaceholder",
    },
    BillingVerificationError: {
      defaultMessage:
        "We couldn\u2019t verify your billing information. Please check your details and try again. Let us know if we can help if the issue persists. <contactLink>Contact Us</contactLink>",
      id: "teamBilling.billingVerificationError",
    },
    ReloadPageError: {
      defaultMessage: "Please reload the page or try again later if the issue persists.",
      id: "teamBilling.reloadPageError",
    },
    CancelSubscription: {
      defaultMessage: "Cancel subscription",
      id: "teamBilling.cancelSubscription",
    },
    AreYouSureCancel: {
      defaultMessage: "Are you sure you want to cancel?",
      id: "teamBilling.areYouSureCancel",
    },
    NotNow: {
      defaultMessage: "Not now",
      id: "teamBilling.notNow",
    },
    KeepTier: {
      defaultMessage: "Keep {tierName}",
      id: "teamBilling.keepTier",
    },
    Continue: {
      defaultMessage: "Continue",
      id: "teamBilling.continue",
    },
    StartsOn: {
      defaultMessage: "Starts on",
      id: "teamBilling.startsOn",
    },
    AutoRenewsOn: {
      defaultMessage: "Auto-renews on",
      id: "teamBilling.autoRenewsOn",
    },
    ExpiresOn: {
      defaultMessage: "Expires on",
      id: "teamBilling.expiresOn",
    },
    GracePeriodTitle: {
      defaultMessage:
        "Payment error - {days} {days, plural, one {day} other {days}} left in grace period",
      id: "teamBilling.gracePeriodTitle",
    },
    UpdateCard: {
      defaultMessage: "Update card",
      id: "teamBilling.updateCard",
    },
    Update: {
      defaultMessage: "Update",
      id: "teamBilling.update",
    },
    GracePeriodText: {
      defaultMessage:
        "Update your payment method to prevent losing access to paid features. Your subscription will be automatically switched to Basic on <bold>{date}</bold>",
      id: "teamBilling.gracePeriodText",
    },
    TeamGracePeriodText: {
      defaultMessage:
        "Update your card details to prevent losing access to {tierName} features. Your subscription will be automatically switched to Basic and {memberCount, plural, =1 {you} other {all {memberCount} team members}} will lose access to the team on <bold>{date}</bold>",
      id: "teamBilling.teamGracePeriodText",
    },
    CancelMessageTeamGracePeriod: {
      defaultMessage:
        "Your subscription will be automatically switched to Basic and all team members will lose access to the team.",
      id: "teamBilling.cancelMessageTeamGracePeriod",
    },
    CancelMessageTeam: {
      defaultMessage:
        "Your subscription will be automatically switched to Basic and all team members will lose access to the team on <styledDate>{date}.</styledDate>",
      id: "teamBilling.cancelMessageTeam",
    },
    CancelMessageSolo: {
      defaultMessage:
        "Your subscription will be automatically switched to Basic and you will lose access to all {tierName} features on <styledDate>{date}.</styledDate>",
      id: "teamBilling.cancelMessageSolo",
    },
  },

  TeamSubscriptionPage: {
    LicenseTitle: {
      defaultMessage: "License",
      id: "teamSubscriptionPage.licenseTitle",
    },
    SubscriptionTitle: {
      defaultMessage: "Subscription",
      id: "teamSubscriptionPage.subscriptionTitle",
    },
    BasicPlanText: {
      defaultMessage: "Shapr3D Basic",
      id: "teamSubscriptionPage.basicPlanText",
    },
    StudioPricingTitle: {
      defaultMessage: "Fuel design growth across every team with the right plan.",
      id: "teamSubscriptionPage.studioPricingTitle",
    },
    Seats: {
      defaultMessage: "Seats",
      id: "teamSubscriptionPage.seats",
    },
    PurchasedVia: {
      defaultMessage: "Purchased via",
      id: "teamSubscriptionPage.purchasedVia",
    },
    AddSeats: {
      defaultMessage: "Add seats",
      id: "teamSubscriptionPage.addSeats",
    },
    AddSeatsTitle: {
      defaultMessage: "Add Seats",
      id: "teamSubscriptionPage.addSeatsTitle",
    },
    CancelSeat: {
      defaultMessage: "Cancel seat",
      id: "teamSubscriptionPage.cancelSeat",
    },
    Manage: {
      defaultMessage: "Manage",
      id: "teamSubscriptionPage.manage",
    },
    ManageTeamSize: {
      defaultMessage: "Manage team size",
      id: "teamSubscriptionPage.manageTeamSize",
    },
    AddingSeatsUnavailable: {
      defaultMessage: "Adding seats to {teamName} is unavailable.",
      id: "teamSubscriptionPage.addingSeatsUnavailable",
    },
    SubscriptionCancelled: {
      defaultMessage: "Your subscription has been cancelled.",
      id: "teamSubscriptionPage.subscriptionCancelled",
    },
    TurnOnAutoRenewalToAdd: {
      defaultMessage: "Turn on auto-renewal to add seats to your team.",
      id: "teamSubscriptionPage.turnOnAutoRenewalToAdd",
    },
    GracePeriodMessage: {
      defaultMessage: "Your subscription is within the grace period.",
      id: "teamSubscriptionPage.gracePeriodMessage",
    },
    UpdateCardToAdd: {
      defaultMessage: "Update your card details to add new seats.",
      id: "teamSubscriptionPage.updateCardToAdd",
    },
    ContactSupportRemoveSeats: {
      defaultMessage: "Please contact support if you want to remove seats from your team.",
      id: "teamSubscriptionPage.contactSupportRemoveSeats",
    },
    ContactSupport: {
      defaultMessage: "Contact support",
      id: "teamSubscriptionPage.contactSupport",
    },
    LearnMoreCollaborating: {
      defaultMessage: "Learn more how to start collaborating with your team.",
      id: "teamSubscriptionPage.learnMoreCollaborating",
    },
    LearnMore: {
      defaultMessage: "Learn more",
      id: "teamSubscriptionPage.learnMore",
    },
    UpdatePaymentInfo: {
      defaultMessage: "Update payment information",
      id: "teamSubscriptionPage.updatePaymentInfo",
    },
    TurnOnAutoRenewal: {
      defaultMessage: "Turn on auto-renewal",
      id: "teamSubscriptionPage.turnOnAutoRenewal",
    },
    TurnOnAutoRenewalInfo: {
      defaultMessage:
        "Turn on auto-renewal to prevent losing access to {tierName} features at the end of the billing cycle.",
      id: "teamSubscriptionPage.turnOnAutoRenewalInfo",
    },
    ChangeToDirectPlan: {
      defaultMessage: "Change to a direct Shapr3D plan",
      id: "teamSubscriptionPage.changeToDirectPlan",
    },
    UpgradeToPro: {
      defaultMessage: "Upgrade to Pro",
      id: "teamSubscriptionPage.upgradeToPro",
    },
    UpgradeToSolo: {
      defaultMessage: "Upgrade to Solo",
      id: "teamSubscriptionPage.upgradeToSolo",
    },
    HowToRenew: {
      defaultMessage: "How to renew?",
      id: "teamSubscriptionPage.howToRenew",
    },
    PlanPaddleOneTimeYearly: {
      defaultMessage: "Shapr3D {tierName} - 1 Year",
      id: "teamSubscriptionPage.planPaddleOneTimeYearly",
    },
    PlanPaddleOneTimeMonthly: {
      defaultMessage: "Shapr3D {tierName} - 1 Month",
      id: "teamSubscriptionPage.planPaddleOneTimeMonthly",
    },
    PlanBilledAnnually: {
      defaultMessage: "Shapr3D {tierName} - Billed annually",
      id: "teamSubscriptionPage.planBilledAnnually",
    },
    PlanBilledMonthly: {
      defaultMessage: "Shapr3D {tierName} - Billed monthly",
      id: "teamSubscriptionPage.planBilledMonthly",
    },
    PlanEdu: {
      defaultMessage: "EDU - Valid for 1 year",
      id: "teamSubscriptionPage.planEdu",
    },
    PlanGift: {
      defaultMessage: "Gift",
      id: "teamSubscriptionPage.planGift",
    },
    PlanTeam: {
      defaultMessage: "Team - Annual plan - You are a member of {teamName}",
      id: "teamSubscriptionPage.planTeam",
    },
    SourceEdu: {
      defaultMessage: "Edu application",
      id: "teamSubscriptionPage.sourceEdu",
    },
    SourceGift: {
      defaultMessage: "Gift licence",
      id: "teamSubscriptionPage.sourceGift",
    },
    SourceShapr3dWebsite: {
      defaultMessage: "{brand} Website",
      id: "teamSubscriptionPage.sourceShapr3dWebsite",
    },
  },

  UpgradeToStudioModal: {
    Title: {
      defaultMessage: "Upgrade to Studio",
      id: "upgradeToStudioModal.title",
    },
    ErrorTitle: {
      defaultMessage: "Upgrade to Studio is unavailable at the moment.",
      id: "upgradeToStudioModal.errorTitle",
    },
    ErrorText: {
      defaultMessage: "Please reload the page or try again later if the issue persists.",
      id: "upgradeToStudioModal.errorText",
    },
    UpgradeButton: {
      defaultMessage: "Upgrade",
      id: "upgradeToStudioModal.upgradeButton",
    },
    ConfirmButton: {
      defaultMessage: "Upgrade to Studio",
      id: "upgradeToStudioModal.confirmButton",
    },
    PaymentErrorTitle: {
      defaultMessage: "Payment error, upgrade to Studio failed.",
      id: "upgradeToStudioModal.paymentErrorTitle",
    },
    PaymentErrorText: {
      defaultMessage: "Update your card details to upgrade your plan to Studio.",
      id: "upgradeToStudioModal.paymentErrorText",
    },
    TertiaryText: {
      defaultMessage:
        "Your card will get charged {currencySymbol}{amount} when you click \u2018Update & upgrade to Studio\u2019. {allPricesInUSD}",
      id: "upgradeToStudioModal.tertiaryText",
    },
    UpdateAndUpgradeCTA: {
      defaultMessage: "Update & upgrade to Studio",
      id: "upgradeToStudioModal.updateAndUpgradeCTA",
    },
    ToastSuccess: {
      defaultMessage: "Your subscription has been upgraded to Studio.",
      id: "upgradeToStudioModal.toastSuccess",
    },
    LearnMoreAboutTeams: {
      defaultMessage: "Learn more about teams.",
      id: "upgradeToStudioModal.learnMoreAboutTeams",
    },
  },

  AddSeatsModal: {
    Title: {
      defaultMessage: "Add seats",
      id: "addSeatsModal.title",
    },
    SubmitButton: {
      defaultMessage: "Buy seats",
      id: "addSeatsModal.submitButton",
    },
    SubmitButtonTrial: {
      defaultMessage: "Add seats to trial",
      id: "addSeatsModal.submitButtonTrial",
    },
    ToastSuccess: {
      defaultMessage:
        "{count, plural, one {# seat added to your team.} other {# seats added to your team.}}",
      id: "addSeatsModal.toastSuccess",
    },
    ErrorTitle: {
      defaultMessage: "Adding new seats is unavailable at the moment.",
      id: "addSeatsModal.errorTitle",
    },
    ErrorText: {
      defaultMessage: "Please reload the page or try again later if the issue persists.",
      id: "addSeatsModal.errorText",
    },
    PaymentErrorTitle: {
      defaultMessage: "Payment error, adding seats failed.",
      id: "addSeatsModal.paymentErrorTitle",
    },
    PaymentErrorText: {
      defaultMessage: "Update your card details to add seats to your team.",
      id: "addSeatsModal.paymentErrorText",
    },
    PaymentCTAText: {
      defaultMessage: "Update & buy seats",
      id: "addSeatsModal.paymentCTAText",
    },
    TertiaryText: {
      defaultMessage:
        "Your card will get charged {currencySymbol}{amount} when you click \u2018Update & buy seats\u2019. {allPricesInUSD}",
      id: "addSeatsModal.tertiaryText",
    },
    LearnMoreAboutTeams: {
      defaultMessage: "Learn more about teams.",
      id: "addSeatsModal.learnMoreAboutTeams",
    },
  },

  PurchaseNotice: {
    TryPro: {
      defaultMessage: "Try Pro",
      id: "purchaseNotice.tryPro",
    },
    SubscribeToPro: {
      defaultMessage: "Subscribe to Pro",
      id: "purchaseNotice.subscribeToPro",
    },
    GetShapr3DPro: {
      defaultMessage: "Get Shapr3D Pro",
      id: "purchaseNotice.getShapr3DPro",
    },
    StartFreeTrial: {
      defaultMessage: "Start 14-day free trial",
      id: "purchaseNotice.startFreeTrial",
    },
    CompareSubscriptions: {
      defaultMessage: "Compare subscriptions",
      id: "purchaseNotice.compareSubscriptions",
    },
    OneYear: {
      defaultMessage: "1 Year",
      id: "purchaseNotice.oneYear",
    },
    OneMonth: {
      defaultMessage: "1 Month",
      id: "purchaseNotice.oneMonth",
    },
  },

  WelcomeModal: {
    SkipForNow: {
      defaultMessage: "Skip for now",
      id: "welcomeModal.skipForNow",
    },
    DownloadApp: {
      defaultMessage: "Download the Shapr3D app to start editing",
      id: "welcomeModal.downloadApp",
    },
    ProCadTitle: {
      defaultMessage: "Pro CAD needs a pro screen.",
      id: "welcomeModal.proCadTitle",
    },
    DesignedFor: {
      defaultMessage: "Shapr3D is designed for macOS, iPadOS, visionOS, and Windows.",
      id: "welcomeModal.designedFor",
    },
    NotAvailableOnPhones: {
      defaultMessage:
        "It isn\u2019t available on phones yet, but your account is ready to go on your desktop or tablet.",
      id: "welcomeModal.notAvailableOnPhones",
    },
    GetDownloadLink: {
      defaultMessage: "Get Download Link",
      id: "welcomeModal.getDownloadLink",
    },
    CheckInbox: {
      defaultMessage: "Check your inbox on a compatible device.",
      id: "welcomeModal.checkInbox",
    },
    EmailSent: {
      defaultMessage: "We\u2019ve sent you an email with the links to download Shapr3D.",
      id: "welcomeModal.emailSent",
    },
    DownloadShapr3D: {
      defaultMessage: "Download Shapr3D",
      id: "welcomeModal.downloadShapr3D",
    },
    SendDownloadLinkError: {
      defaultMessage: "Something went wrong. Please try again.",
      id: "welcomeModal.sendDownloadLinkError",
    },
  },

  CancellationSurveyModal: {
    WhyCancelling: {
      defaultMessage: "Why are you cancelling?",
      id: "cancellationSurveyModal.whyCancelling",
    },
    Context: {
      defaultMessage: "Cancelling your {tierName} subscription (expires {expirationDate})",
      id: "cancellationSurveyModal.context",
    },
    ChangeSubscription: {
      defaultMessage: "I want to change to a monthly / yearly subscription",
      id: "cancellationSurveyModal.changeSubscription",
    },
    TooExpensive: {
      defaultMessage: "It's too expensive",
      id: "cancellationSurveyModal.tooExpensive",
    },
    FoundAlternative: {
      defaultMessage: "Found an alternative",
      id: "cancellationSurveyModal.foundAlternative",
    },
    NotUsingEnough: {
      defaultMessage: "I'm not using it enough",
      id: "cancellationSurveyModal.notUsingEnough",
    },
    MissingFeatures: {
      defaultMessage: "I miss features",
      id: "cancellationSurveyModal.missingFeatures",
    },
    TechnicalIssues: {
      defaultMessage: "I have too many technical issues",
      id: "cancellationSurveyModal.technicalIssues",
    },
    OtherReason: {
      defaultMessage: "Other",
      id: "cancellationSurveyModal.otherReason",
    },
    WhichAlternative: {
      defaultMessage: "Which alternative?",
      id: "cancellationSurveyModal.whichAlternative",
    },
    WhichFeatures: {
      defaultMessage: "Which features do you miss?",
      id: "cancellationSurveyModal.whichFeatures",
    },
    Fusion: {
      defaultMessage: "Fusion",
      id: "cancellationSurveyModal.fusion",
    },
    SketchUp: {
      defaultMessage: "SketchUp",
      id: "cancellationSurveyModal.sketchUp",
    },
    SolidWorks: {
      defaultMessage: "SolidWorks",
      id: "cancellationSurveyModal.solidWorks",
    },
    Assemblies: {
      defaultMessage: "Assemblies",
      id: "cancellationSurveyModal.assemblies",
    },
    BillOfMaterials: {
      defaultMessage: "Bill of Materials",
      id: "cancellationSurveyModal.billOfMaterials",
    },
    Threads: {
      defaultMessage: "Threads",
      id: "cancellationSurveyModal.threads",
    },
    Other: {
      defaultMessage: "Other",
      id: "cancellationSurveyModal.other",
    },
    KeepTier: {
      defaultMessage: "Keep {tierName}",
      id: "cancellationSurveyModal.keepTier",
    },
    CancelSubscription: {
      defaultMessage: "Cancel subscription",
      id: "cancellationSurveyModal.cancelSubscription",
    },
  },

  Comments: {
    Title: {
      defaultMessage: "Comments",
      id: "comments.title",
    },
    ToolButtonTitle: {
      defaultMessage: "Comments",
      id: "comments.toolButtonTitle",
    },
    ToolButtonAlt: {
      defaultMessage: "Comments",
      id: "comments.toolButtonAlt",
    },
    AddCommentPlaceholder: {
      defaultMessage: "Add comment...",
      id: "comments.addCommentPlaceholder",
    },
    SendButton: {
      defaultMessage: "Send",
      id: "comments.sendButton",
    },
    SubmitError: {
      defaultMessage: "Something went wrong. Please try again.",
      id: "comments.submitError",
    },
    UnknownUser: {
      defaultMessage: "Unknown user",
      id: "comments.unknownUser",
    },
    EmptyState: {
      defaultMessage:
        "No comments yet. To place a comment use the Add Comment tool or Ctrl+Shift+click on the model.",
      id: "comments.emptyState",
    },
    EmptyStateShort: {
      defaultMessage: "No comments yet.",
      id: "comments.emptyStateShort",
    },
    LoadError: {
      defaultMessage: "Something went wrong while loading comments. Please try again later.",
      id: "comments.loadError",
    },
    LoginPrompt: {
      defaultMessage:
        "Gather feedback on your designs!<br></br>Log in to manage sharing settings and enable commenting.",
      id: "comments.loginPrompt",
    },
    NewCommentTitle: {
      defaultMessage: "New comment",
      id: "comments.newCommentTitle",
    },
    DeleteMenuItem: {
      defaultMessage: "Delete comment...",
      id: "comments.deleteMenuItem",
    },
    DeleteModalTitle: {
      defaultMessage: "Delete comment?",
      id: "comments.deleteModalTitle",
    },
    DeleteModalBody: {
      defaultMessage: "This comment will be deleted immediately. You can\u2019t undo this action.",
      id: "comments.deleteModalBody",
    },
    DeleteButton: {
      defaultMessage: "Delete",
      id: "comments.deleteButton",
    },
    DeleteError: {
      defaultMessage: "Failed to delete comment. You may try again later.",
      id: "comments.deleteError",
    },
  },

  ModelViewer: {
    AddCommentTitle: {
      defaultMessage: "Add Comment (Ctrl+Shift+click)",
      id: "modelViewer.addCommentTitle",
    },
    AddCommentAlt: {
      defaultMessage: "Add Comment",
      id: "modelViewer.addCommentAlt",
    },
    AddCommentLabel: {
      defaultMessage: "Add Comment",
      id: "modelViewer.addCommentLabel",
    },
    PlaceCommentLabel: {
      defaultMessage: "Place Comment",
      id: "modelViewer.placeCommentLabel",
    },
    LoginModalTitle: {
      defaultMessage: "You need to log in to add a comment",
      id: "modelViewer.loginModalTitle",
    },
    LoginModalText: {
      defaultMessage: "You are about to leave this page to log in or sign up.",
      id: "modelViewer.loginModalText",
    },
    LoginButton: {
      defaultMessage: "Log in",
      id: "modelViewer.loginButton",
    },
  },

  InvalidEduRequest: {
    IneligibleEmailTitle: {
      defaultMessage: "Ineligible email address",
      id: "invalidEduRequest.ineligibleEmail.title",
    },
    IneligibleEmailText: {
      defaultMessage:
        "Your email address isn\u2019t eligible for the Shapr3D EDU license. Make sure you\u2019re using the email address provided by your institution.",
      id: "invalidEduRequest.ineligibleEmail.text",
    },
    IneligibleEmailCheckEligibility: {
      defaultMessage: "To check your eligibility, visit <link>EDU license eligibility.</link>",
      id: "invalidEduRequest.ineligibleEmail.checkEligibility",
    },
    IneligibleEmailButton: {
      defaultMessage: "Change my email",
      id: "invalidEduRequest.ineligibleEmail.button",
    },
    UnavailableTitle: {
      defaultMessage: "Educational licenses are not available in your region.",
      id: "invalidEduRequest.unavailable.title",
    },
    UnavailableText: {
      defaultMessage:
        "Shapr3D for educational purposes isn\u2019t available in your region yet, but you can still use the standard version to create models.",
      id: "invalidEduRequest.unavailable.text",
    },
    UnavailableButton: {
      defaultMessage: "See Subscriptions",
      id: "invalidEduRequest.unavailable.button",
    },
    EmailVerificationTitle: {
      defaultMessage: "Email verification required",
      id: "invalidEduRequest.emailVerification.title",
    },
    EmailVerificationText: {
      defaultMessage:
        "You must verify your email address to apply for an EDU license. Please check your email or click below to verify.",
      id: "invalidEduRequest.emailVerification.text",
    },
    EmailVerificationCheckEligibility: {
      defaultMessage: "To check your eligibility, visit <link>EDU license eligibility.</link>",
      id: "invalidEduRequest.emailVerification.checkEligibility",
    },
    EmailVerificationButton: {
      defaultMessage: "Verify your email",
      id: "invalidEduRequest.emailVerification.button",
    },
  },

  NonAutoRenewingUpgradeModal: {
    Title: {
      defaultMessage: "Upgrade unavailable",
      id: "nonAutoRenewingUpgradeModal.title",
    },
    Body: {
      defaultMessage: "Your subscription has been cancelled. Turn on auto-renewal to upgrade.",
      id: "nonAutoRenewingUpgradeModal.body",
    },
    CloseButton: {
      defaultMessage: "Close",
      id: "nonAutoRenewingUpgradeModal.closeButton",
    },
  },
};

export default messages;
